import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { styled as styled$1, css } from 'styled-components';
import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import gsap from 'gsap';
import { useMemo, useState, useEffect, useRef, useCallback } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { createPortal } from 'react-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import { createChart } from 'lightweight-charts';
import zlib from 'browserify-zlib';
import { v4 } from 'uuid';
import { Buffer } from 'buffer';
import { useQuery } from '@tanstack/react-query';
import CloseIcon from '@mui/icons-material/Close';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ButtonStyled = styled.button(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    padding: 20px;\n    border-radius: .5em;\n    min-width: 64px;\n\n    outline: none;\n    border: none;\n\n    &:hover {\n        cursor: pointer;\n        background-color: #4976c2!important;\n    }\n\n    user-select: none;\n\n    font-size: clamp(13px, 16px, 22px);\n    font-weight: 600;\n    font-style: normal;\n"], ["\n    padding: 20px;\n    border-radius: .5em;\n    min-width: 64px;\n\n    outline: none;\n    border: none;\n\n    &:hover {\n        cursor: pointer;\n        background-color: #4976c2!important;\n    }\n\n    user-select: none;\n\n    font-size: clamp(13px, 16px, 22px);\n    font-weight: 600;\n    font-style: normal;\n"])));
var templateObject_1$g;

var BASE_URL = "/";
var GREEN = "#0bba74";
var RED = "#ff4761";
var DARK_RED = "#d91f11";
var BLUE = "#3366cc";
var LIGHT_BLACK = "#252525";
var BLACK = "#131313";
var GREY = "#E4E4E4";
var DARK_GREY = "#303030";
var GOLD = "#FFA800";
var WHITE = "#FFFFFF";
var HEADER_HEIGHT = '72px';
var MIN_INFO_WIDTH = '450px';
var SCROLL_WIDTH = '32px';
var AUTH_TOKEN = "authToken";
var REFRESH_TOKEN = "refreshToken";
var typeOptions = [
    { option: "futures", name: "Фьючерс-Фьючерс" },
    { option: "spot", name: "Спот-Фьючерс" },
    { option: "margin", name: "Фьючерс-Маржа" }
];
var shortExchanges = { "mexc": "mxc", "kucoin": "kuc", "gateio": "gat", "binance": "bin", "bybit": "byb", "coinex": "coi", "okx": "okx", "bitget": "btg", "bingx": "bgx", "bitmex": "btx", "huobi": "huo", "bitmart": "btm", 'xt': 'xt', 'lbank': 'lbk', 'hyper': 'hyp', 'ourbit': 'our', 'blofin': 'blf', 'phemex': 'phx', 'paradex': 'pdex', 'aster': 'astr', 'lighter': 'lgt', 'apex': 'apx' };

var ThemeStore = /** @class */ (function () {
    function ThemeStore() {
        Object.defineProperty(this, "theme", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this.theme = localStorage.getItem('theme') || "light";
    }
    Object.defineProperty(ThemeStore.prototype, "textColor", {
        get: function () {
            if (this.theme === "dark") {
                return WHITE;
            }
            return BLACK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "bgColor", {
        get: function () {
            if (this.theme === "dark") {
                return BLACK;
            }
            return WHITE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "greenColor", {
        get: function () {
            return GREEN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "redColor", {
        get: function () {
            return RED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "alternativeColor", {
        get: function () {
            if (this.theme === "dark") {
                return DARK_GREY;
            }
            return BLUE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "gridColor", {
        get: function () {
            if (this.theme === "dark") {
                return DARK_GREY;
            }
            return GREY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "dropdownColor", {
        get: function () {
            if (this.theme === "dark") {
                return LIGHT_BLACK;
            }
            return WHITE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "btnColor", {
        get: function () {
            if (this.theme === "dark") {
                return BLUE;
            }
            return BLACK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "anotherTheme", {
        get: function () {
            if (this.theme === "dark") {
                return "light";
            }
            return "dark";
        },
        enumerable: false,
        configurable: true
    });
    return ThemeStore;
}());
var themeStore = new ThemeStore();

var Button = observer(function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return (jsx(ButtonStyled, __assign({ onClick: onClick, style: {
            backgroundColor: themeStore.btnColor,
            color: WHITE,
        } }, { children: children })));
});

var DropdownStyled$1 = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    position: relative;\n\n    button {\n        width: 100%;\n        position: relative;\n        padding: 8px 20px 8px 8px;\n        border-radius: 8px;\n\n        p {\n            font-size: 18px;\n        }\n\n        .arrow {\n            position: absolute;\n            right: 0;\n            top: 7px;\n        }\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n"], ["\n    position: relative;\n\n    button {\n        width: 100%;\n        position: relative;\n        padding: 8px 20px 8px 8px;\n        border-radius: 8px;\n\n        p {\n            font-size: 18px;\n        }\n\n        .arrow {\n            position: absolute;\n            right: 0;\n            top: 7px;\n        }\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n"])));
var OptionsStyled = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    width: 100%;\n\n    p {\n        font-size: 18px;\n        padding: 8px 16px 8px 8px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    box-shadow: 0 1px 1px ", ";\n\n"], ["\n    position: absolute;\n    left: 0;\n    width: 100%;\n\n    p {\n        font-size: 18px;\n        padding: 8px 16px 8px 8px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    box-shadow: 0 1px 1px ", ";\n\n"])), BLACK);
var templateObject_1$f, templateObject_2$6;

var Dropdown$1 = observer(function (_a) {
    var value = _a.value, setValue = _a.setValue, options = _a.options, className = _a.className;
    var tl = useMemo(function () {
        return gsap.timeline();
    }, []);
    var _b = useState('none'), dropdownDisplay = _b[0], setDropdownDisplay = _b[1];
    return (jsxs(DropdownStyled$1, __assign({ className: className }, { children: [jsxs("button", __assign({ style: {
                    backgroundColor: themeStore.bgColor,
                    color: themeStore.textColor,
                    border: "1px solid ".concat(themeStore.textColor)
                }, onClick: function () {
                    if (dropdownDisplay === "none") {
                        setDropdownDisplay("block");
                        tl.to("#timeframe-arrow", {
                            duration: 0,
                            rotate: 180
                        });
                    }
                    else {
                        setDropdownDisplay("none");
                        tl.to("#timeframe-arrow", {
                            duration: 0,
                            rotate: 0
                        });
                    }
                } }, { children: [jsx("p", { children: value }), " ", jsx(ArrowDropDownIcon, { id: "timeframe-arrow", className: "arrow" })] })), jsx(OptionsStyled, __assign({ style: {
                    display: dropdownDisplay
                } }, { children: options.map(function (opt) {
                    return jsx("p", __assign({ onClick: function () {
                            setValue(opt);
                            setDropdownDisplay("none");
                            tl.to("#timeframe-arrow", {
                                duration: 0,
                                rotate: 0
                            });
                        }, style: {
                            backgroundColor: themeStore.dropdownColor,
                            color: themeStore.textColor,
                        }, onMouseOver: function (e) {
                            //@ts-ignore
                            e.target.style.backgroundColor = themeStore.gridColor;
                        }, onMouseLeave: function (e) {
                            //@ts-ignore
                            e.target.style.backgroundColor = themeStore.dropdownColor;
                        } }, { children: opt }), opt);
                }) }))] })));
});

var LoaderStyled = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    img {\n        height: 100%;\n        width: 100%;\n    }\n\n    @keyframes rotate {\n        from {\n          rotate: 0;\n        }\n      \n        to {\n          rotate: 360deg;\n        }\n      }\n"], ["\n    img {\n        height: 100%;\n        width: 100%;\n    }\n\n    @keyframes rotate {\n        from {\n          rotate: 0;\n        }\n      \n        to {\n          rotate: 360deg;\n        }\n      }\n"])));
var templateObject_1$e;

var loader = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20200%20200%22%3E%3Ccircle%20fill%3D%22none%22%20stroke-opacity%3D%221%22%20stroke%3D%22%233366CC%22%20stroke-width%3D%22.5%22%20cx%3D%22100%22%20cy%3D%22100%22%20r%3D%220%22%3E%3Canimate%20attributeName%3D%22r%22%20calcMode%3D%22spline%22%20dur%3D%222%22%20values%3D%221%3B80%22%20keyTimes%3D%220%3B1%22%20keySplines%3D%220%20.2%20.5%201%22%20repeatCount%3D%22indefinite%22%3E%3C%2Fanimate%3E%3Canimate%20attributeName%3D%22stroke-width%22%20calcMode%3D%22spline%22%20dur%3D%222%22%20values%3D%220%3B25%22%20keyTimes%3D%220%3B1%22%20keySplines%3D%220%20.2%20.5%201%22%20repeatCount%3D%22indefinite%22%3E%3C%2Fanimate%3E%3Canimate%20attributeName%3D%22stroke-opacity%22%20calcMode%3D%22spline%22%20dur%3D%222%22%20values%3D%221%3B0%22%20keyTimes%3D%220%3B1%22%20keySplines%3D%220%20.2%20.5%201%22%20repeatCount%3D%22indefinite%22%3E%3C%2Fanimate%3E%3C%2Fcircle%3E%3C%2Fsvg%3E";

var Loader = observer(function (_a) {
    _a.size;
    return (jsx(LoaderStyled, { children: jsx("img", { src: loader }) }));
});

var ModalStyled = styled$1.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 100;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: rgba(0,0,0, .5);\n"], ["\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 100;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: rgba(0,0,0, .5);\n"])));
var templateObject_1$d;

var Modal = function (props) {
    var isOpen = props.isOpen, children = props.children;
    var display = useMemo(function () {
        return isOpen
            ? 'flex'
            : 'none';
    }, [isOpen]);
    return (createPortal(jsx(ModalStyled, __assign({ style: {
            display: display
        } }, { children: children })), document.body));
};

var DropdownStyled = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    max-height: 200px;\n    top: 100%;\n\n    display: flex;\n    flex-direction: column;\n\n    border: none;\n    border-radius: 4px;\n    box-shadow: 0 1px 1px ", ";\n\n    overflow-y: auto;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n\n    z-index: 10;\n"], ["\n    position: absolute;\n    width: 100%;\n    max-height: 200px;\n    top: 100%;\n\n    display: flex;\n    flex-direction: column;\n\n    border: none;\n    border-radius: 4px;\n    box-shadow: 0 1px 1px ", ";\n\n    overflow-y: auto;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n\n    z-index: 10;\n"])), BLACK);
var templateObject_1$c;

var Dropdown = function (_a) {
    var children = _a.children, style = _a.style, onMouseOver = _a.onMouseOver, onMouseLeave = _a.onMouseLeave, onBlur = _a.onBlur;
    return (jsx(DropdownStyled, __assign({ style: style, onMouseOver: function () { return onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(); }, onMouseLeave: onMouseLeave, onBlur: onBlur, onWheel: function (e) {
            e.stopPropagation();
        } }, { children: children })));
};

var SearchSelectStyled = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n    position: relative;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 1em 0;\n\n    p.title {\n        position: absolute;\n        left: 0.35em;\n        top: -1.2em;\n        font-size: 12px;\n    }\n\n    input {\n        width: 100%;\n        padding: 12px;\n        outline: none;\n        border: 1px solid ", ";\n        border-radius: 8px;\n\n        &::-webkit-input-placeholder {\n            color: ", ";\n        }\n\n        ", "\n\n        font-size: clamp(12px,1.2vw,16px);\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n    }\n\n    p.choice-funding {\n        position: absolute;\n        right: 25px;\n        pointer-events: none;\n    }\n\n    .dropdown-icon {\n        width: 25px;\n        position: absolute;\n        right: 0;\n        pointer-events: none;\n    }\n\n    div.option {\n        position: relative;\n        padding: 1em 5px 1em 1em;\n        width: 100%;\n        height: 2.5em;\n        // min-height: 25px;\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;;\n\n        &:hover {\n            cursor: pointer;\n        }\n\n        white-space: nowrap;\n        font-size: clamp(12px,1.4vw,16px);\n\n        span {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: .5em;\n          width: 100%;\n          background-color: rgba(0,0,0,0) !important;\n        }\n\n        p {\n            background-color: inherit!important;\n            color: inherit!important;\n            pointer-events: none;\n            user-select: none;\n\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n        input {\n          justify-self: start;\n          width: fit-content;\n        }\n    }\n\n    p.funding {\n        width: fit-content;\n        font-family: monospace;\n        overflow: visible !important;\n    }\n"], ["\n    position: relative;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 1em 0;\n\n    p.title {\n        position: absolute;\n        left: 0.35em;\n        top: -1.2em;\n        font-size: 12px;\n    }\n\n    input {\n        width: 100%;\n        padding: 12px;\n        outline: none;\n        border: 1px solid ", ";\n        border-radius: 8px;\n\n        &::-webkit-input-placeholder {\n            color: ", ";\n        }\n\n        ", "\n\n        font-size: clamp(12px,1.2vw,16px);\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n    }\n\n    p.choice-funding {\n        position: absolute;\n        right: 25px;\n        pointer-events: none;\n    }\n\n    .dropdown-icon {\n        width: 25px;\n        position: absolute;\n        right: 0;\n        pointer-events: none;\n    }\n\n    div.option {\n        position: relative;\n        padding: 1em 5px 1em 1em;\n        width: 100%;\n        height: 2.5em;\n        // min-height: 25px;\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;;\n\n        &:hover {\n            cursor: pointer;\n        }\n\n        white-space: nowrap;\n        font-size: clamp(12px,1.4vw,16px);\n\n        span {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: .5em;\n          width: 100%;\n          background-color: rgba(0,0,0,0) !important;\n        }\n\n        p {\n            background-color: inherit!important;\n            color: inherit!important;\n            pointer-events: none;\n            user-select: none;\n\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n        input {\n          justify-self: start;\n          width: fit-content;\n        }\n    }\n\n    p.funding {\n        width: fit-content;\n        font-family: monospace;\n        overflow: visible !important;\n    }\n"])), BLACK, BLACK, function (props) { return props.$dark && css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n            &::-webkit-input-placeholder {\n                color: ", ";\n            }\n        "], ["\n            &::-webkit-input-placeholder {\n                color: ", ";\n            }\n        "])), WHITE); });
var templateObject_1$b, templateObject_2$5;

var useDebounce = function (cb, deps, timeout) {
    var _a = useState(), timer = _a[0], setTimer = _a[1];
    useEffect(function () {
        clearTimeout(timer);
        setTimer(setTimeout(function () {
            cb();
        }, timeout || 500));
    }, deps);
};

var SearchSelect = observer(function (_a) {
    var title = _a.title, choice = _a.choice, setChoice = _a.setChoice, options = _a.options, className = _a.className;
    var multiple = useMemo(function () {
        return Array.isArray(choice);
    }, [choice]);
    var placeHolder = useMemo(function () {
        if (!Array.isArray(choice)) {
            return (choice === null || choice === void 0 ? void 0 : choice.name) || "Не выбрано";
        }
        if (!choice.length) {
            return "Не выбрано";
        }
        if (choice.length <= 2) {
            return choice.map(function (ch) { return ch.name; }).join(', ');
        }
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043E: ".concat(choice.length);
    }, [choice]);
    var tl = useMemo(function () {
        return gsap.timeline();
    }, []);
    var _b = useState(""), search = _b[0], setSearch = _b[1];
    var _c = useState(options), filteredOptions = _c[0], setFilteredOptions = _c[1];
    var _d = useState("none"), display = _d[0], setDisplay = _d[1];
    var inputRef = useRef(null);
    useRef(null);
    var overDropdown = useRef(false);
    useDebounce(function () {
        setFilteredOptions(options === null || options === void 0 ? void 0 : options.filter(function (opt) { return opt === null || opt === void 0 ? void 0 : opt.name.toLowerCase().includes(search.toLowerCase()); }));
    }, [search, options], 300);
    var onClickSingle = function (opt) {
        setChoice(opt);
        setSearch("");
        setDisplay("none");
        tl.to("#dropdown-icon-".concat(title), {
            duration: 0,
            rotate: 0
        });
    };
    var onClickMultiple = function (opt) {
        if (!Array.isArray(choice)) {
            return;
        }
        if (choice.find(function (val) { return val.option === opt.option; })) {
            setChoice(choice.filter(function (val) { return val.option !== opt.option; }));
        }
        else {
            setChoice(__spreadArray(__spreadArray([], choice, true), [opt], false));
        }
    };
    var onBlur = function () {
        var _a;
        if (!overDropdown.current) {
            setDisplay("none");
            setSearch("");
            tl.to("#dropdown-icon-".concat(title), {
                duration: 0,
                rotate: 0
            });
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    };
    return (jsxs(SearchSelectStyled, __assign({ className: className, "$dark": themeStore.theme === "dark" }, { children: [jsx("p", __assign({ className: "title", style: { color: themeStore.textColor } }, { children: title })), jsx("input", { style: {
                    backgroundColor: themeStore.bgColor,
                    borderColor: themeStore.textColor,
                    color: themeStore.textColor,
                }, ref: inputRef, placeholder: placeHolder, type: "text", value: search, onChange: function (e) { return setSearch(e.target.value); }, onFocus: function () {
                    setDisplay("flex");
                    tl.to("#dropdown-icon-".concat(title), {
                        duration: 0,
                        rotate: 180
                    });
                }, onBlur: onBlur }), !Array.isArray(choice) && (choice === null || choice === void 0 ? void 0 : choice.funding) !== undefined && jsxs("p", __assign({ style: { color: themeStore.textColor }, className: "choice-funding funding" }, { children: [parseFloat(choice === null || choice === void 0 ? void 0 : choice.funding).toFixed(2), "%", (choice === null || choice === void 0 ? void 0 : choice.interval) !== undefined && " ".concat(choice.interval, "\u0447")] })), jsx(ArrowDropDownIcon, { style: { color: themeStore.textColor }, id: "dropdown-icon-".concat(title), className: "dropdown-icon" }), jsxs(Dropdown, __assign({ style: { display: display }, onMouseOver: function () {
                    overDropdown.current = true;
                }, onMouseLeave: function () {
                    overDropdown.current = false;
                }, onBlur: multiple ? onBlur : undefined }, { children: [filteredOptions.map(function (opt, i) {
                        return jsxs("div", __assign({ className: "option", style: { color: themeStore.textColor, backgroundColor: themeStore.dropdownColor }, onClick: function () {
                                var _a;
                                multiple ? onClickMultiple(opt) : onClickSingle(opt);
                                multiple && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus());
                            }, onMouseOver: function (e) {
                                //@ts-ignore
                                e.target.style.backgroundColor = themeStore.gridColor;
                            }, onMouseLeave: function (e) {
                                //@ts-ignore
                                e.target.style.backgroundColor = themeStore.dropdownColor;
                            } }, { children: [jsxs("span", __assign({ style: { color: themeStore.textColor } }, { children: [multiple &&
                                            jsx("input", { name: "checked", type: "checkbox", readOnly: true, checked: !!choice.find(function (val) { return val.option === opt.option; }), style: {
                                                    accentColor: themeStore.textColor,
                                                    color: themeStore.dropdownColor
                                                } }), jsx("p", __assign({ className: "option" }, { children: opt.name }))] })), (opt === null || opt === void 0 ? void 0 : opt.funding) !== undefined &&
                                    jsxs("p", __assign({ className: "funding" }, { children: [parseFloat(opt === null || opt === void 0 ? void 0 : opt.funding).toFixed(2), "%", (opt === null || opt === void 0 ? void 0 : opt.interval) !== undefined && " ".concat(opt === null || opt === void 0 ? void 0 : opt.interval, "\u0447")] }))] }), JSON.stringify(opt.option));
                    }), filteredOptions.length === 0 &&
                        jsx("div", __assign({ className: "option", style: { color: themeStore.textColor, backgroundColor: themeStore.dropdownColor }, onClick: function () {
                                setDisplay("none");
                                tl.to("#dropdown-icon-".concat(title), {
                                    duration: 0,
                                    rotate: 0
                                });
                            } }, { children: jsx("p", __assign({ className: "option" }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" })) }))] }))] })));
});

var TextInputWrap = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  p.label {\n    font-size: .75em;\n    margin-bottom: 4px;\n  }\n\n  p.tooltip {\n    font-size: .8em;\n    color: ", ";\n    margin-top: 2px;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  p.label {\n    font-size: .75em;\n    margin-bottom: 4px;\n  }\n\n  p.tooltip {\n    font-size: .8em;\n    color: ", ";\n    margin-top: 2px;\n  }\n"])), DARK_RED);
var TextInputStyled = styled.input(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 100%;\n  padding: 12px;\n  border: 1px solid;\n  border-radius: 8px;\n\n  font-size: 1em;\n\n  &:focus {\n    outline: 1px solid ", ";\n    border-color: ", " !important;\n  }\n"], ["\n  width: 100%;\n  padding: 12px;\n  border: 1px solid;\n  border-radius: 8px;\n\n  font-size: 1em;\n\n  &:focus {\n    outline: 1px solid ", ";\n    border-color: ", " !important;\n  }\n"])), BLUE, BLUE);
var templateObject_1$a, templateObject_2$4;

var TextInput = function (props) {
    var _a;
    var hasError = props.hasError, label = props.label, tooltip = props.tooltip, value = props.value, setValue = props.setValue, args = __rest(props, ["hasError", "label", "tooltip", "value", "setValue"]);
    var inputRef = useRef(null);
    return (jsxs(TextInputWrap, { children: [jsx("p", __assign({ className: "label", style: (_a = {},
                    _a[hasError ? "color" : ''] = DARK_RED,
                    _a) }, { children: label })), jsx(TextInputStyled, __assign({ ref: inputRef, style: {
                    borderColor: hasError ? DARK_RED : themeStore.gridColor,
                    backgroundColor: themeStore.bgColor,
                    color: themeStore.textColor,
                }, onFocus: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select(); }, value: value, onChange: function (e) { setValue(e.target.value); } }, args)), tooltip && jsx("p", __assign({ className: "tooltip" }, { children: tooltip }))] }));
};

var sunSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%20%20%20%20%3Cpath%20d%3D%22M11.667%2017.625C14.6873%2017.625%2017.1357%2015.1066%2017.1357%2012C17.1357%208.8934%2014.6873%206.375%2011.667%206.375C8.64669%206.375%206.19824%208.8934%206.19824%2012C6.19824%2015.1066%208.64669%2017.625%2011.667%2017.625Z%22%20%20%20%20%20%20%20%20%20%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M11.667%203.375V1.5%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M5.73724%205.90102L4.44824%204.5752%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M3.28092%2012H1.45801%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M5.73724%2018.0986L4.44824%2019.4245%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M11.667%2020.625V22.5%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M17.5957%2018.0986L18.8847%2019.4245%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M20.0518%2012H21.8747%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M17.5957%205.90102L18.8847%204.5752%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var moonSvg = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M20.6949%2014.022C19.2491%2014.3631%2017.7427%2014.3209%2016.317%2013.8993C14.8914%2013.4777%2013.5932%2012.6905%2012.5443%2011.6116C11.4953%2010.5327%2010.73%209.19744%2010.3201%207.73105C9.91026%206.26467%209.86922%204.71522%2010.2009%203.22805L10.2008%203.22803C8.67855%203.5892%207.2781%204.3629%206.14479%205.4688C5.01148%206.5747%204.18664%207.97247%203.75591%209.517C3.32518%2011.0615%203.30426%2012.6965%203.69533%2014.2521C4.0864%2015.8078%204.87519%2017.2274%205.97982%2018.3636C7.08444%2019.4998%208.46462%2020.3111%209.97706%2020.7134C11.4895%2021.1156%2013.079%2021.0941%2014.5807%2020.6511C16.0823%2020.208%2017.4412%2019.3596%2018.5164%2018.1939C19.5916%2017.0283%2020.3438%2015.5878%2020.695%2014.0221L20.6949%2014.022Z%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var ToggleStyled = styled.img(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    position: absolute;\n    left: auto;\n    right: 0;\n"], ["\n    position: absolute;\n    left: auto;\n    right: 0;\n"])));
var templateObject_1$9;

var Toggle = observer(function () {
    var toggleImg = useMemo(function () {
        if (themeStore.theme === "dark") {
            return moonSvg;
        }
        return sunSvg;
    }, [themeStore.theme]);
    return (jsx(ToggleStyled, { id: "theme-toggle", src: toggleImg }));
});

var ThemePickerStyled = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    position: relative;\n    height: 32px;\n    width: 56px;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    user-select: none;\n    background-color: ", ";\n"], ["\n    position: relative;\n    height: 32px;\n    width: 56px;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    user-select: none;\n    background-color: ", ";\n"])), GREY);
var templateObject_1$8;

var audioSrc = "data:audio/mpeg;base64,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";

var logoSvg = "data:image/svg+xml,%3Csvg%20width%3D%2268%22%20height%3D%2252%22%20viewBox%3D%220%200%2068%2052%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M42.8093%200.164978C41.9661%200.277575%2040.9313%200.450099%2040.5097%200.548486C38.4912%201.01895%2035.6323%202.17458%2035.7124%202.48765C35.737%202.58342%2036.4404%204.57572%2037.2754%206.91492L38.794%2011.1683L39.3082%2010.5948C40.0171%209.80444%2041.6659%208.96962%2043.2886%208.57993C44.9969%208.16955%2048.1944%208.13186%2049.9383%208.50163C52.979%209.14632%2054.8215%2011.0189%2055.6906%2014.3479C55.9382%2015.2962%2055.9989%2015.3906%2056.3617%2015.3929C56.5811%2015.3943%2058.8206%2015.3112%2061.3384%2015.2082L65.9163%2015.021L65.8111%2013.9314C65.4753%2010.4525%2064.2723%207.58371%2062.1896%205.29547C59.7808%202.64875%2056.783%201.13062%2052.3912%200.333023C50.4413%20-0.0209848%2044.9264%20-0.117827%2042.8093%200.164978ZM19.1797%202.37768C16.6017%209.07141%2014.2991%2015.0329%2012.0661%2020.7963C9.29536%2027.9475%207.60113%2032.3332%205.6222%2037.4773C5.0502%2038.9639%203.55128%2042.8397%202.29122%2046.0901L0%2052L5.15092%2051.9594L10.3017%2051.9188L13.7938%2042.7288C15.7145%2037.6743%2018.8771%2029.1252%2020.8219%2023.7309C22.7668%2018.3366%2024.4047%2013.8743%2024.4621%2013.8145C24.5192%2013.7549%2025.7318%2016.8826%2027.1563%2020.765C28.581%2024.6475%2031.818%2033.2626%2034.3498%2039.91L38.953%2051.996H43.1515C45.4607%2051.996%2047.3177%2051.9433%2047.2783%2051.8789C47.1974%2051.7472%2046.3965%2049.526%2040.275%2032.4576C33.4444%2013.4123%2029.3947%202.08144%2029.3947%202.01456C29.3947%201.98074%2027.1332%201.95294%2024.369%201.95294H19.3433L19.1797%202.37768ZM40.8929%2016.9944C40.8929%2017.1107%2045.1585%2028.852%2045.225%2028.919C45.2677%2028.962%2046.5007%2029.3078%2047.9653%2029.6874C54.1897%2031.301%2055.8648%2032.1431%2056.8464%2034.1521C57.2927%2035.0652%2057.3254%2035.2385%2057.2749%2036.4284C57.2297%2037.4986%2057.1376%2037.8854%2056.7301%2038.7167C55.8248%2040.5625%2053.8055%2042.1556%2051.7364%2042.6563C51.1269%2042.8038%2050.5481%2042.9674%2050.4505%2043.0197C50.3283%2043.0851%2050.72%2044.3711%2051.7029%2047.1307L53.1329%2051.1465L53.6436%2051.1051C54.5104%2051.0347%2056.6132%2050.4586%2057.9894%2049.9143C62.3261%2048.199%2065.577%2044.5504%2066.8412%2039.9792C67.1241%2038.9568%2067.1696%2038.3895%2067.1665%2035.9328C67.1633%2033.4788%2067.1153%2032.901%2066.8268%2031.8398C65.7184%2027.7623%2063.077%2024.6831%2059.0618%2022.7875C57.1173%2021.8695%2053.6941%2020.7702%2049.2484%2019.6364C45.2848%2018.6253%2043.2358%2017.994%2041.6978%2017.31C41.2552%2017.113%2040.8929%2016.9711%2040.8929%2016.9944ZM21.076%2042.0184C19.1586%2047.3069%2017.5898%2051.6806%2017.5898%2051.7377C17.5898%2051.7949%2020.7538%2051.8415%2024.6209%2051.8415H31.652L30.6878%2049.1772C27.3349%2039.9117%2024.6259%2032.467%2024.5965%2032.4373C24.5777%2032.4185%2022.9935%2036.7299%2021.076%2042.0184Z%22%20fill%3D%22%233366CC%22%2F%3E%3C%2Fsvg%3E";

dayjs.extend(utc);
function getFormatedLocalTime(date) {
    var transformedDate = dayjs.utc(date);
    return +transformedDate - new Date().getTimezoneOffset() * 60 * 1e3;
}
var audio = new Audio(audioSrc);
var getNotificationPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (Notification.permission === 'granted') {
                    return [2 /*return*/, true];
                }
                if (Notification.permission === 'denied') {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, Notification.requestPermission()];
            case 1: return [2 /*return*/, (_a.sent()) === 'granted'];
        }
    });
}); };
var showNotification = function (_a) {
    var title = _a.title, body = _a.body;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getNotificationPermission()];
                case 1:
                    if (!_b.sent()) return [3 /*break*/, 3];
                    new Notification(title, { body: body, icon: logoSvg });
                    return [4 /*yield*/, audio.play()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
};
function wait(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, ms); })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}

var UserStore = /** @class */ (function () {
    function UserStore() {
        Object.defineProperty(this, "_isAuth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_socketBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this._isAuth = true;
        this._baseUrl = '';
        this._socketBaseUrl = '';
    }
    Object.defineProperty(UserStore.prototype, "getBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            count = 0;
                            _a.label = 1;
                        case 1:
                            if (!(!this._baseUrl && count < 50)) return [3 /*break*/, 3];
                            count++;
                            return [4 /*yield*/, wait(50)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            if (!this._baseUrl) {
                                throw new Error("UserStore.baseUrl in not defined. Define it in your root app.");
                            }
                            return [2 /*return*/, this._baseUrl];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "getSocketBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            count = 0;
                            _a.label = 1;
                        case 1:
                            if (!(!this._socketBaseUrl && count < 50)) return [3 /*break*/, 3];
                            count++;
                            return [4 /*yield*/, wait(50)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            if (!this._socketBaseUrl) {
                                throw new Error("UserStore.socketBaseUrl in not defined. Define it in your root app.");
                            }
                            return [2 /*return*/, this._socketBaseUrl];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "setBaseUrls", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            this._baseUrl = options.base;
            this._socketBaseUrl = options.socket;
        }
    });
    Object.defineProperty(UserStore.prototype, "isAuth", {
        get: function () {
            return this._isAuth;
        },
        set: function (val) {
            this._isAuth = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "authToken", {
        get: function () {
            return localStorage.getItem(AUTH_TOKEN);
        },
        set: function (val) {
            localStorage.setItem(AUTH_TOKEN, val || '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "refreshToken", {
        get: function () {
            return localStorage.getItem(REFRESH_TOKEN);
        },
        set: function (val) {
            localStorage.setItem(REFRESH_TOKEN, val || '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "loadDefaultOptions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (query) {
            query = query.slice(1);
            var pairs = query.split('&');
            for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
                var pair = pairs_1[_i];
                var _a = pair.split('='); _a[0]; _a[1];
            }
            this.authToken = localStorage.getItem(AUTH_TOKEN);
            this.refreshToken = localStorage.getItem(REFRESH_TOKEN);
        }
    });
    return UserStore;
}());
var userStore = new UserStore();

function getHeaders() {
    return __awaiter(this, void 0, void 0, function () {
        var authToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!localStorage) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 50); })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 2:
                    authToken = localStorage.getItem(AUTH_TOKEN) || '';
                    return [2 /*return*/, {
                            "Authorization": authToken,
                            "Content-Type": "application/json",
                        }];
            }
        });
    });
}
var isRefreshRunning = false;
function withRetry(req) {
    return __awaiter(this, void 0, void 0, function () {
        var res, e_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 5]);
                    return [4 /*yield*/, req()];
                case 1:
                    res = _a.sent();
                    if (res.status === 401) {
                        throw 401;
                    }
                    return [3 /*break*/, 5];
                case 2:
                    e_1 = _a.sent();
                    if (e_1 !== 401) {
                        throw e_1;
                    }
                    if (!isRefreshRunning) {
                        isRefreshRunning = true;
                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var baseUrl, refreshRes, _a, _b, _c, refresh_token, access_token;
                            var _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                                    case 1:
                                        baseUrl = _e.sent();
                                        _a = fetch;
                                        _b = ["".concat(baseUrl, "/refresh")];
                                        _d = {
                                            method: "POST"
                                        };
                                        return [4 /*yield*/, getHeaders()];
                                    case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_d.headers = _e.sent(),
                                                _d.body = JSON.stringify({ refresh_token: localStorage.getItem(REFRESH_TOKEN) }),
                                                _d)]))];
                                    case 3:
                                        refreshRes = _e.sent();
                                        return [4 /*yield*/, refreshRes.json()];
                                    case 4:
                                        _c = _e.sent(), refresh_token = _c.refresh_token, access_token = _c.access_token;
                                        localStorage.setItem(AUTH_TOKEN, access_token);
                                        localStorage.setItem(REFRESH_TOKEN, refresh_token);
                                        isRefreshRunning = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 0);
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!isRefreshRunning) return [3 /*break*/, 2];
                                        return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 100); })];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 0];
                                    case 2:
                                        resolve(true);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, req()];
                case 4:
                    res = _a.sent();
                    if (res.status === 401) {
                        userStore.isAuth = false;
                        throw new Error();
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, res];
            }
        });
    });
}

function getExchanges() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, json, err_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            var _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        _a = fetch;
                                        _b = ["".concat(baseUrl, "/exchanges")];
                                        _c = {};
                                        return [4 /*yield*/, getHeaders()];
                                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                _c)]))];
                                    case 2: return [2 /*return*/, _d.sent()];
                                }
                            });
                        }); })];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    json = _a.sent();
                    return [2 /*return*/, json.markets];
                case 5:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    });
}

var ExchangesStore = /** @class */ (function () {
    function ExchangesStore() {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this._data = [];
    }
    Object.defineProperty(ExchangesStore.prototype, "load", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var exchanges;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getExchanges()];
                        case 1:
                            exchanges = _a.sent();
                            runInAction(function () {
                                _this._data = exchanges;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ExchangesStore.prototype, "data", {
        get: function () {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExchangesStore.prototype, "getNameByMarket", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (market) {
            var _a, _b;
            if (!market) {
                return '';
            }
            return (_b = (_a = this._data) === null || _a === void 0 ? void 0 : _a.filter(function (ex) { return ex.market === market; })[0]) === null || _b === void 0 ? void 0 : _b.name;
        }
    });
    return ExchangesStore;
}());
var exchangesStore = new ExchangesStore();

var MobileStore = /** @class */ (function () {
    function MobileStore() {
        Object.defineProperty(this, "isMobile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chartMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this.chartMode = "chart";
    }
    Object.defineProperty(MobileStore.prototype, "changeChartMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.chartMode === "chart") {
                this.chartMode = "info";
            }
            else {
                this.chartMode = "chart";
            }
        }
    });
    Object.defineProperty(MobileStore.prototype, "isChartVisible", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (window.innerWidth > 2 * parseInt(MIN_INFO_WIDTH) || !this.chartMode) {
                return true;
            }
            return this.chartMode === "chart";
        }
    });
    Object.defineProperty(MobileStore.prototype, "isInfoVisible", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (window.innerWidth > 2 * parseInt(MIN_INFO_WIDTH) || !this.chartMode) {
                return true;
            }
            return this.chartMode === "info";
        }
    });
    return MobileStore;
}());
var mobileStore = new MobileStore();

var ChartStore = /** @class */ (function () {
    function ChartStore() {
        Object.defineProperty(this, "_fetchSpreadInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getEnterSpread", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_timeFrames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                { value: 5, title: '5м' },
                { value: 15, title: '15м' },
                { value: 60, title: '1ч' },
                { value: 240, title: '4ч' },
            ]
        });
        makeAutoObservable(this);
        this._fetchSpreadInfo = function () { throw new Error("CharStore.fetchEnterSpread in not defined, define it in your root app."); };
        this.getEnterSpread = function () { throw new Error("CharStore.getEnterSpread in not defined, define it in your root app."); };
    }
    Object.defineProperty(ChartStore.prototype, "getSpreadInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._fetchSpreadInfo(data)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    });
    Object.defineProperty(ChartStore.prototype, "fetchSpreadInfo", {
        set: function (fn) {
            this._fetchSpreadInfo = fn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartStore.prototype, "timeFrames", {
        get: function () {
            return this._timeFrames;
        },
        set: function (value) {
            this._timeFrames = value;
        },
        enumerable: false,
        configurable: true
    });
    return ChartStore;
}());
var chartStore = new ChartStore();

var ThemePicker = observer(function () {
    var changePosition = useCallback(function () {
        var tl = gsap.timeline();
        if (themeStore.theme === "light") {
            tl.to("#theme-toggle", {
                duration: .1,
                right: 0,
                left: 'auto',
            });
        }
        if (themeStore.theme === "dark") {
            tl.to("#theme-toggle", {
                duration: .1,
                left: 0,
                right: 'auto,'
            });
        }
    }, [themeStore.theme]);
    return (jsx(ThemePickerStyled, __assign({ onClick: function () {
            themeStore.theme = themeStore.anotherTheme;
            localStorage.setItem('theme', themeStore.theme);
            changePosition();
        }, style: { backgroundColor: themeStore.alternativeColor } }, { children: jsx(Toggle, {}) })));
});

var LogoStyled = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 11px;\n\n    img {\n        height: 100%;\n    }\n\n    h1 {\n        font-family: sans-serif;\n        font-size : 14px;\n        line-height: 110%;\n        font-weight: normal;\n\n        @media(max-width: 720px) {\n            font-size : 10px;\n        }\n\n    }\n"], ["\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 11px;\n\n    img {\n        height: 100%;\n    }\n\n    h1 {\n        font-family: sans-serif;\n        font-size : 14px;\n        line-height: 110%;\n        font-weight: normal;\n\n        @media(max-width: 720px) {\n            font-size : 10px;\n        }\n\n    }\n"])));
var templateObject_1$7;

var Logo = observer(function () {
    return (jsxs(LogoStyled, { children: [jsx("img", { src: logoSvg }), jsx("h1", __assign({ style: { color: themeStore.textColor } }, { children: "Arbitrage Services" }))] }));
});

var StringContainerStyled = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    position: relative;\n    width: fit-content !important;\n    padding: 6px 24px 6px 6px !important;\n    border-radius: 8px !important;\n    user-select: none;\n\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: start !important;\n    align-items: center !important;\n\n    overflow: hidden;\n    \n    &:hover {\n        cursor: pointer;\n    }\n\n    &:active {\n        outline: 1px solid #b7b7b7;\n    }\n\n    .title {\n        position: absolute;\n        top: -1.5em;\n        left: 0;\n        font-size: inherit;\n    }\n\n    p {\n        font-family: \"Proxima Nova\", sans-serif;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-wrap: nowrap;\n        height: auto !important;\n        font-size: .8em;\n    }\n\n    .copy {\n        height: .8em;\n        width: .8em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n\n    .done {\n        height: .6em;\n        width: .6em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n"], ["\n    position: relative;\n    width: fit-content !important;\n    padding: 6px 24px 6px 6px !important;\n    border-radius: 8px !important;\n    user-select: none;\n\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: start !important;\n    align-items: center !important;\n\n    overflow: hidden;\n    \n    &:hover {\n        cursor: pointer;\n    }\n\n    &:active {\n        outline: 1px solid #b7b7b7;\n    }\n\n    .title {\n        position: absolute;\n        top: -1.5em;\n        left: 0;\n        font-size: inherit;\n    }\n\n    p {\n        font-family: \"Proxima Nova\", sans-serif;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-wrap: nowrap;\n        height: auto !important;\n        font-size: .8em;\n    }\n\n    .copy {\n        height: .8em;\n        width: .8em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n\n    .done {\n        height: .6em;\n        width: .6em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n"])));
var templateObject_1$6;

var StringContainer = function (_a) {
    var content = _a.content, allowCopy = _a.allowCopy, className = _a.className, style = _a.style, short = _a.short;
    var _b = useState(false), isCopied = _b[0], setIsCopied = _b[1];
    if (!content) {
        return jsx(Fragment, {});
    }
    return (jsxs(StringContainerStyled, __assign({ className: className, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (allowCopy) {
                    navigator.clipboard.writeText(content).then(function () {
                        setIsCopied(true);
                    });
                }
                return [2 /*return*/];
            });
        }); }, style: __assign({ pointerEvents: allowCopy ? 'inherit' : 'none', border: "1px solid ".concat(themeStore.textColor) }, style) }, { children: [jsx("p", __assign({ className: "text2" }, { children: short ? "".concat(content.substring(0, 4), "...").concat(content.substring(content.length - 4)) : content })), allowCopy && jsx(ContentCopyIcon, { className: "copy" }), allowCopy && isCopied && jsx(DoneIcon, { className: "done" })] })));
};

var AuthFormStyled = styled.form(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  position: relative;\n  padding: 64px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  width: 750px;\n  height: 550px;\n  max-width: 100%;\n  max-height: 100%;\n  margin: 32px;\n  border-radius: 32px;\n\n  h1 {\n    position: absolute;\n    top: 16px;\n    text-align: center;\n  }\n\n  & > * {\n    width: 100%;\n    max-width: 350px;\n  }\n\n  button {\n    margin-top: 32px;\n  }\n"], ["\n  position: relative;\n  padding: 64px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  width: 750px;\n  height: 550px;\n  max-width: 100%;\n  max-height: 100%;\n  margin: 32px;\n  border-radius: 32px;\n\n  h1 {\n    position: absolute;\n    top: 16px;\n    text-align: center;\n  }\n\n  & > * {\n    width: 100%;\n    max-width: 350px;\n  }\n\n  button {\n    margin-top: 32px;\n  }\n"])));
var NotFoundWrap = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  width: 100%;\n  background-color: #ffe0de;\n  color: #d91f11;\n  padding: 19px 23px;\n  margin-bottom: 20px;\n  border-radius: 12px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n\n  p {\n    text-align: start;\n  }\n"], ["\n  width: 100%;\n  background-color: #ffe0de;\n  color: #d91f11;\n  padding: 19px 23px;\n  margin-bottom: 20px;\n  border-radius: 12px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n\n  p {\n    text-align: start;\n  }\n"])));
var templateObject_1$5, templateObject_2$3;

function signIn(options) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, res, _a, access_token, refresh_token;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _b.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/login"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(options)
                        })];
                case 2:
                    res = _b.sent();
                    if (res.status !== 200) {
                        userStore.isAuth = false;
                        throw new Error();
                    }
                    return [4 /*yield*/, res.json()];
                case 3:
                    _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token;
                    localStorage.setItem(AUTH_TOKEN, access_token);
                    localStorage.setItem(REFRESH_TOKEN, refresh_token);
                    userStore.isAuth = true;
                    return [2 /*return*/];
            }
        });
    });
}

var AuthForm = function (props) {
    var isOpen = props.isOpen;
    var _a = useState(''), email = _a[0], setEmail = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), notFound = _c[0], setNotFound = _c[1];
    var _d = useState(''), emailTooltip = _d[0], setEmailTooltip = _d[1];
    var _e = useState(''), passwordTooltip = _e[0], setPasswordTooltip = _e[1];
    useEffect(function () {
        if (emailTooltip && email) {
            setEmailTooltip('');
        }
    }, [email]);
    useEffect(function () {
        if (passwordTooltip && password) {
            setPasswordTooltip('');
        }
    }, [password]);
    useEffect(function () {
        setNotFound(false);
    }, [email, password]);
    return (jsx(Modal, __assign({ isOpen: isOpen }, { children: jsxs(AuthFormStyled, __assign({ style: {
                backgroundColor: themeStore.bgColor,
                color: themeStore.textColor,
            } }, { children: [jsx("h1", __assign({ style: {
                        color: BLUE
                    } }, { children: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F" })), notFound &&
                    jsx(NotFoundWrap, { children: jsx("p", { children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D" }) }), jsx(TextInput, { hasError: emailTooltip || notFound ? true : false, label: "E-mail", tooltip: emailTooltip, value: email, setValue: setEmail, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail", autoComplete: "email", name: "email", type: "email" }), jsx(TextInput, { hasError: passwordTooltip || notFound ? true : false, label: "\u041F\u0430\u0440\u043E\u043B\u044C", tooltip: passwordTooltip, value: password, setValue: setPassword, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", autoComplete: "current-password", name: "password", type: "password" }), jsx(Button, __assign({ onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                        var hasError;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    e.preventDefault();
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    hasError = false;
                                    if (!email) {
                                        setEmailTooltip("Данное поле является обязательным");
                                        hasError = true;
                                    }
                                    if (!password) {
                                        setPasswordTooltip("Данное поле является обязательным");
                                        hasError = true;
                                    }
                                    if (hasError) {
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, signIn({ email: email, password: password })];
                                case 2:
                                    _b.sent();
                                    setEmail('');
                                    setPassword('');
                                    setNotFound(false);
                                    return [3 /*break*/, 4];
                                case 3:
                                    _b.sent();
                                    setNotFound(true);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); } }, { children: jsx("p", { children: "\u0412\u043E\u0439\u0442\u0438" }) }))] })) })));
};

var HeaderStyled = styled.header(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 100;\n    left: 0;\n    top: 0;\n\n    height: ", ";\n    width: 100%;\n    padding: 10px 2em 10px 2em;\n\n    background-color: ", ";\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n"], ["\n    position: fixed;\n    z-index: 100;\n    left: 0;\n    top: 0;\n\n    height: ", ";\n    width: 100%;\n    padding: 10px 2em 10px 2em;\n\n    background-color: ", ";\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n"])), HEADER_HEIGHT, BLACK);
var TailStyled = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n"])));
var templateObject_1$4, templateObject_2$2;

var Header = observer(function () {
    return (jsxs(HeaderStyled, __assign({ style: {
            backgroundColor: themeStore.bgColor,
            borderBottom: "1px solid ".concat(themeStore.textColor)
        } }, { children: [jsx(Logo, {}), jsx(TailStyled, { children: jsx(ThemePicker, {}) })] })));
});

var GraphStyled = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: calc(100vh - ", " - 20px);\n    \n    display: flex;\n    flex-direction: row;\n"], ["\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: calc(100vh - ", " - 20px);\n    \n    display: flex;\n    flex-direction: row;\n"])), HEADER_HEIGHT);
var GraphContainer = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    position: relative;\n    width: calc(100% * 2 / 3);\n    max-width: calc(100% - ", ");\n    min-width: ", ";\n    height: 100%;\n\n    overflow-x: auto;\n\n    @media(max-width: calc(2*", ")) {\n        height: calc(100% - 10px);\n        margin-bottom: ", ";\n        width: 100%;\n        min-width: 100%;\n    }\n"], ["\n    position: relative;\n    width: calc(100% * 2 / 3);\n    max-width: calc(100% - ", ");\n    min-width: ", ";\n    height: 100%;\n\n    overflow-x: auto;\n\n    @media(max-width: calc(2*", ")) {\n        height: calc(100% - 10px);\n        margin-bottom: ", ";\n        width: 100%;\n        min-width: 100%;\n    }\n"])), MIN_INFO_WIDTH, MIN_INFO_WIDTH, MIN_INFO_WIDTH, SCROLL_WIDTH);
var InfoContainer = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    position: relative;\n    width: calc(100% / 3);\n    min-width: ", ";\n    height: 100%;\n    min-height: calc(750px - ", ");\n\n    display: flex;\n    flex-direction: column;\n\n    @media(max-width: calc(2*", ")) {\n      width: 100%;\n      min-width: 100%;\n    }\n"], ["\n    position: relative;\n    width: calc(100% / 3);\n    min-width: ", ";\n    height: 100%;\n    min-height: calc(750px - ", ");\n\n    display: flex;\n    flex-direction: column;\n\n    @media(max-width: calc(2*", ")) {\n      width: 100%;\n      min-width: 100%;\n    }\n"])), MIN_INFO_WIDTH, HEADER_HEIGHT, MIN_INFO_WIDTH);
var TimeFrameStyled = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n\n    padding: 1em;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 1em;\n\n    h2 {\n        display: flex;\n        align-items: center;\n        font-weight: bold;\n    }\n\n    .timeframe-dropdown {\n        width: 60px;\n    }\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n\n    padding: 1em;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 1em;\n\n    h2 {\n        display: flex;\n        align-items: center;\n        font-weight: bold;\n    }\n\n    .timeframe-dropdown {\n        width: 60px;\n    }\n"])));
var templateObject_1$3, templateObject_2$1, templateObject_3$1, templateObject_4$1;

var ChartStyled = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    #tv-attr-logo {\n      display: none;\n    }\n\n    div.not-found {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        z-index: 100;\n\n        h1 {\n            position: absolute;\n            user-select: none;\n        }\n    }\n\n    .rate {\n      position: absolute;\n      font-size: 12px;\n      white-space: nowrap;\n    }\n\n"], ["\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    #tv-attr-logo {\n      display: none;\n    }\n\n    div.not-found {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        z-index: 100;\n\n        h1 {\n            position: absolute;\n            user-select: none;\n        }\n    }\n\n    .rate {\n      position: absolute;\n      font-size: 12px;\n      white-space: nowrap;\n    }\n\n"])));
var templateObject_1$2;

function getHistory(options) {
    return __awaiter(this, void 0, void 0, function () {
        var exchange, coin, baseUrl, searchParams, response, json;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    exchange = options.exchange, coin = options.coin;
                    if (!exchange) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    searchParams = new URLSearchParams("coin=".concat(coin));
                    return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            var _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        _a = fetch;
                                        _b = ["".concat(baseUrl, "/history/").concat(exchange, "?").concat(searchParams)];
                                        _c = {};
                                        return [4 /*yield*/, getHeaders()];
                                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                _c)]))];
                                    case 2: return [2 /*return*/, _d.sent()];
                                }
                            });
                        }); })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    return [2 /*return*/, json];
            }
        });
    });
}

var useResize = function (cb, deps) {
    if (deps === void 0) { deps = []; }
    useEffect(function () {
        window.addEventListener('resize', cb);
        return function () {
            window.removeEventListener('resize', cb);
        };
    }, deps);
};

function isNewTimeFrame(curTimeFrame, timeFrame) {
    // let time: TSeconds = Date.now() / 1000 - timeFrame*60
    // time -= new Date().getTimezoneOffset()*60
    var time = +dayjs() / 1000 - new Date().getTimezoneOffset() * 60 - timeFrame * 60;
    return time > curTimeFrame;
}
function wasDisconnected(curTimeFrame, timeFrame) {
    //   let time: TSeconds = Date.now() / 1000 - 2*timeFrame*60
    //   time -= new Date().getTimezoneOffset()*60
    var time = +dayjs() / 1000 - new Date().getTimezoneOffset() * 60 - 2 * timeFrame * 60;
    return time > curTimeFrame;
}
function getGeneralTitles(type, statistics, volume) {
    var _a, _b, _c, _d, _e, _f;
    var spread = statistics && 'short' in statistics ? (parseFloat((_a = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _a === void 0 ? void 0 : _a.current_funding) - parseFloat((_b = statistics === null || statistics === void 0 ? void 0 : statistics.long) === null || _b === void 0 ? void 0 : _b.current_funding)).toFixed(2) : NaN;
    if (type === 'spot' && statistics && "short" in statistics) {
        spread = ((_c = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _c === void 0 ? void 0 : _c.current_funding) || NaN;
    }
    if (type === 'margin' && statistics && 'short' in statistics) {
        spread = ((_d = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _d === void 0 ? void 0 : _d.current_funding) ? (-((_e = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _e === void 0 ? void 0 : _e.current_funding) || NaN) : (((_f = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _f === void 0 ? void 0 : _f.current_funding) || NaN);
    }
    return {
        "Вход": statistics ? "".concat(getEnterSpread(statistics, volume), "%") : "-",
        "Выход": statistics ? "".concat(getCloseSpread(statistics, volume), "%") : "-",
        "Спред": !Number.isNaN(spread) ? "".concat(spread, "%") : '-',
        "Комиссия": statistics && 'fee' in statistics ? getValue((statistics === null || statistics === void 0 ? void 0 : statistics.fee) || '') : '',
    };
}
function getLongShortTitles(longShort) {
    if (!longShort) {
        return {};
    }
    return {
        "Ставка": getValue(longShort.current_funding) || '-',
        // "Прогноз": getValue(longShort.next_funding) || '-' ,
        "Отклонение": getValue(longShort.mark_index) || '-',
        "Стакан": getValue(longShort.orderbook_spread) || '-',
        "Период": getValue(longShort.interval, 'ч') || '-',
        "Лимит": longShort.limit ? longShort.limit.toFixed(0) + '$' : '-'
    };
}
function getValue(val, postfix) {
    if (postfix === void 0) { postfix = "%"; }
    var parsed = parseFloat(val);
    if (Number.isNaN(parsed)) {
        return null;
    }
    return "".concat(parsed).concat(postfix);
}
function getEnterSpread(message, volume) {
    var _a, _b;
    if (!("long" in message)) {
        return "- ";
    }
    var asks = (_a = message.long.orderbook) === null || _a === void 0 ? void 0 : _a.asks;
    var bids = (_b = message.short.orderbook) === null || _b === void 0 ? void 0 : _b.bids;
    if (!asks || !bids) {
        return "- ";
    }
    var askPrice = findAvgPrice(asks, volume);
    var bidPrice = findAvgPrice(bids, volume);
    var spread = getSpread(askPrice, bidPrice);
    return spread;
}
function getCloseSpread(message, volume) {
    var _a, _b, _c, _d;
    if (!('short' in message)) {
        return "- ";
    }
    var asks = (_b = (_a = message === null || message === void 0 ? void 0 : message.short) === null || _a === void 0 ? void 0 : _a.orderbook) === null || _b === void 0 ? void 0 : _b.asks;
    var bids = (_d = (_c = message === null || message === void 0 ? void 0 : message.long) === null || _c === void 0 ? void 0 : _c.orderbook) === null || _d === void 0 ? void 0 : _d.bids;
    if (!asks || !bids) {
        return "- ";
    }
    var askPrice = findAvgPrice(asks, volume);
    var bidPrice = findAvgPrice(bids, volume);
    return getSpread(askPrice, bidPrice);
}
function getSpread(askPrice, bidPrice) {
    return ((bidPrice - askPrice) / (askPrice + bidPrice) * 2 * 100).toFixed(2);
}
function findAvgPrice(orders, volume) {
    var _a;
    volume = volume || 1;
    var result = orders.reduce(function (acc, item) {
        if (acc.remain_volume <= 0)
            return acc;
        var addVolume = Math.min(parseInt(item.volume), acc.remain_volume);
        return __assign(__assign({}, acc), { price_volume: acc.price_volume + item.price * addVolume, remain_volume: Math.round(acc.remain_volume - addVolume) });
    }, { price_volume: 0, remain_volume: volume });
    if (!result.price_volume) {
        result = { price_volume: Number((_a = orders.at(0)) === null || _a === void 0 ? void 0 : _a.price), remain_volume: 0 };
        volume = 1;
    }
    return result.price_volume / (volume - result.remain_volume);
}

function useCheckMobile() {
    return useMemo(function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true; })(navigator.userAgent || navigator.vendor);
        return check;
    }, []);
}

var Chart = observer(function (_a) {
    var type = _a.type, coin = _a.coin, long = _a.long, short = _a.short, statistics = _a.statistics, chain = _a.chain, timeFrame = _a.timeFrame;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var isMobile = useCheckMobile();
    useEffect(function () {
        if (isMobile) {
            var page = document.getElementById('statistics-page');
            page === null || page === void 0 ? void 0 : page.scrollTo(page.scrollWidth, 0);
        }
    }, [isMobile]);
    var _c = useState([]), longHistory = _c[0], setLongHistory = _c[1];
    var _d = useState([]), shortHistory = _d[0], setShortHistory = _d[1];
    var chartWidth = useRef(0);
    var fetchHistoryInterval = useRef();
    useEffect(function () {
        var fetchHistory = function (isNotFirstCall) {
            if (isNotFirstCall === void 0) { isNotFirstCall = true; }
            var minute = dayjs().minute();
            if (isNotFirstCall && (minute % 5 !== 0 || minute === 0))
                return;
            if (short && type === "futures" || type === "spot") {
                getHistory({ exchange: short, coin: coin }).then(function (val) { return setShortHistory(val); });
            }
            if (long && type === "futures" || type === "margin") {
                getHistory({ exchange: long, coin: coin }).then(function (val) { return setLongHistory(val); });
            }
        };
        fetchHistory(false);
        fetchHistoryInterval.current = setInterval(fetchHistory, 1 * 60 * 1e3);
        return function () {
            clearInterval(fetchHistoryInterval.current);
        };
    }, [type, coin, long, short]);
    var chartProperties = useMemo(function () {
        return {
            timeScale: {
                timeVisible: true,
                secondsVisible: false,
                borderVisible: false,
            },
            layout: {
                background: { color: themeStore.bgColor },
                textColor: themeStore.textColor
            },
            grid: {
                vertLines: { color: themeStore.gridColor, },
                horzLines: { color: themeStore.gridColor, },
            },
            rightPriceScale: {
                borderVisible: false,
            },
            crosshair: {
                mode: 0,
                horzLine: {
                    labelBackgroundColor: themeStore.textColor,
                    color: themeStore.textColor,
                },
                vertLine: {
                    labelBackgroundColor: themeStore.textColor,
                    color: themeStore.textColor,
                }
            }
        };
    }, [themeStore.theme]);
    var priceLineOptions = useMemo(function () {
        return {
            price: 0,
            color: themeStore.theme === "light" ? BLUE : WHITE,
            lineWidth: 2,
            lineStyle: 3,
        };
    }, [themeStore.theme]);
    var chartRef = useRef(null);
    var _e = useState(), lastData = _e[0], setLastData = _e[1];
    var _f = useMemo(function () {
        if (chartRef.current) {
            //@ts-ignore
            var chart_1 = createChart(chartRef.current, chartProperties);
            var candleSeries_1 = chart_1.addCandlestickSeries();
            var timeScale_1 = chart_1.timeScale();
            var priceLine_1 = candleSeries_1.createPriceLine(priceLineOptions);
            return [chart_1, candleSeries_1, priceLine_1, timeScale_1];
        }
        return [];
    }, [chartRef.current]), chart = _f[0], candleSeries = _f[1], priceLine = _f[2], timeScale = _f[3];
    var _g = useState([]), longRates = _g[0], setLongRates = _g[1];
    var _h = useState([]), shortRates = _h[0], setShortRates = _h[1];
    var getRates = function () {
        var longRates = longHistory === null || longHistory === void 0 ? void 0 : longHistory.map(function (item) {
            var date = Math.round((parseInt(item.timestamp) - new Date().getTimezoneOffset() * 60 * 1e3) / 1000 / 100) * 100;
            var coordinate = timeScale === null || timeScale === void 0 ? void 0 : timeScale.timeToCoordinate(date);
            return { coordinate: coordinate, rate: (item.rate * 100).toFixed(2) + '%' };
        }).filter(function (item) { return item.coordinate && item.coordinate > 0 && item.coordinate < chartWidth.current; });
        setLongRates(longRates || []);
        var shortRates = shortHistory === null || shortHistory === void 0 ? void 0 : shortHistory.map(function (item) {
            var date = Math.round((parseInt(item.timestamp) - new Date().getTimezoneOffset() * 60 * 1e3) / 1000 / 100) * 100;
            var coordinate = timeScale === null || timeScale === void 0 ? void 0 : timeScale.timeToCoordinate(date);
            return { coordinate: coordinate, rate: (item.rate * 100).toFixed(2) + '%' };
        }).filter(function (item) { return item.coordinate && item.coordinate > 0 && item.coordinate < chartWidth.current; });
        setShortRates(shortRates || []);
    };
    var cleanRates = function () {
        setLongRates([]);
        setShortRates([]);
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (isLoading || !timeScale) {
            return;
        }
        getRates();
        (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', cleanRates);
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('touchstart', cleanRates);
        (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('mouseup', getRates);
        (_d = chartRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('wheel', getRates);
        (_e = chartRef.current) === null || _e === void 0 ? void 0 : _e.addEventListener('touchend', getRates);
        return function () {
            var _a, _b, _c, _d, _e;
            (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', cleanRates);
            (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('touchstart', cleanRates);
            (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('mouseup', getRates);
            (_d = chartRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('wheel', getRates);
            (_e = chartRef.current) === null || _e === void 0 ? void 0 : _e.removeEventListener('touchend', getRates);
        };
    }, [longHistory, shortHistory, timeScale, isLoading]);
    useEffect(function () {
        getRates();
    }, [chartWidth.current]);
    useEffect(function () {
        chart === null || chart === void 0 ? void 0 : chart.applyOptions(chartProperties);
    }, [chartProperties]);
    useEffect(function () {
        priceLine === null || priceLine === void 0 ? void 0 : priceLine.applyOptions(priceLineOptions);
    }, [priceLineOptions]);
    var chartResize = useCallback(function () {
        var height;
        var width;
        if (isMobile || window.innerWidth < 2 * parseInt(MIN_INFO_WIDTH)) {
            height = window.innerHeight - parseInt(HEADER_HEIGHT) - 30;
            width = window.innerWidth - parseInt(SCROLL_WIDTH);
        }
        else {
            height = window.innerHeight - parseInt(HEADER_HEIGHT) - (isMobile ? 70 : 30);
            width = Math.max(Math.min(Math.ceil(window.innerWidth * 2 / 3), window.innerWidth - parseInt(MIN_INFO_WIDTH)) - 20, parseInt(MIN_INFO_WIDTH)) - parseInt(SCROLL_WIDTH);
        }
        chartWidth.current = width;
        chart === null || chart === void 0 ? void 0 : chart.resize(width, height, true);
    }, [chart, isMobile]);
    useEffect(function () {
        chartResize === null || chartResize === void 0 ? void 0 : chartResize();
    }, [chartResize]);
    useResize(function () {
        chartResize === null || chartResize === void 0 ? void 0 : chartResize();
    }, [chartResize]);
    var setData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var vals, time;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!(type && coin && candleSeries && timeFrame)) return [3 /*break*/, 2];
                    return [4 /*yield*/, chartStore.getSpreadInfo({ type: type, coin: coin, long: long, short: short, network: chain, timeFrame: timeFrame })];
                case 1:
                    vals = _f.sent();
                    if (vals.length > 0) {
                        candleSeries.setData(vals.map(function (val) { return (__assign(__assign({}, val), { time: getFormatedLocalTime(val.time) / 1000 - timeFrame * 60 })); }));
                        time = getFormatedLocalTime((_a = vals.at(-1)) === null || _a === void 0 ? void 0 : _a.time) / 1000 - timeFrame * 60;
                        setLastData({
                            time: time,
                            open: ((_b = vals.at(-1)) === null || _b === void 0 ? void 0 : _b.open) || 0,
                            close: ((_c = vals.at(-1)) === null || _c === void 0 ? void 0 : _c.close) || 0,
                            high: ((_d = vals.at(-1)) === null || _d === void 0 ? void 0 : _d.high) || 0,
                            low: ((_e = vals.at(-1)) === null || _e === void 0 ? void 0 : _e.low) || 0,
                        });
                    }
                    setIsLoading(false);
                    _f.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [type, coin, long, short, chain, timeFrame, candleSeries, isLoading]);
    useEffect(function () {
        if (timeFrame && setData) {
            setIsLoading(true);
            setData();
        }
    }, [candleSeries, timeFrame]);
    var fetchingSpreadInfo = useRef(false);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var close_1, time, open_1, high, low;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(statistics && lastData && !fetchingSpreadInfo.current)) return [3 /*break*/, 5];
                        close_1 = parseFloat(chartStore.getEnterSpread(statistics)) || lastData.close;
                        time = lastData.time;
                        open_1 = lastData.open;
                        high = Math.max(lastData.high, close_1);
                        low = Math.min(lastData.low, close_1);
                        if (!wasDisconnected(time, timeFrame)) return [3 /*break*/, 2];
                        if (fetchingSpreadInfo.current) {
                            return [2 /*return*/];
                        }
                        fetchingSpreadInfo.current = true;
                        return [4 /*yield*/, setData()];
                    case 1:
                        _a.sent();
                        fetchingSpreadInfo.current = false;
                        return [2 /*return*/];
                    case 2:
                        if (isNewTimeFrame(time, timeFrame)) {
                            time += timeFrame * 60;
                            open_1 = lastData.close;
                            high = open_1;
                            low = open_1;
                        }
                        if (!isNewTimeFrame(time, timeFrame)) return [3 /*break*/, 4];
                        fetchingSpreadInfo.current = true;
                        return [4 /*yield*/, setData()];
                    case 3:
                        _a.sent();
                        fetchingSpreadInfo.current = false;
                        return [3 /*break*/, 5];
                    case 4:
                        setLastData({
                            open: open_1,
                            time: time,
                            close: close_1,
                            high: high,
                            low: low,
                        });
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [statistics, candleSeries, timeFrame]);
    useEffect(function () {
        candleSeries === null || candleSeries === void 0 ? void 0 : candleSeries.update(lastData);
    }, [lastData]);
    return (jsxs(ChartStyled, __assign({ ref: chartRef, onWheel: function (e) { return e.stopPropagation(); } }, { children: [lastData === undefined &&
                jsx("div", __assign({ className: 'not-found', style: { color: themeStore.textColor } }, { children: isLoading
                        ? jsx(Loader, { size: 'large' })
                        : jsx("h1", { children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }) })), jsxs("span", __assign({ style: {
                    width: "calc(".concat(chartWidth.current, "px - 56px)"),
                    height: "calc(".concat(timeScale === null || timeScale === void 0 ? void 0 : timeScale.height(), "px + 3em)"),
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    overflow: 'hidden',
                    zIndex: 1e3
                } }, { children: [longRates === null || longRates === void 0 ? void 0 : longRates.map(function (rate) {
                        var _a, _b;
                        return (jsxs("b", __assign({ id: "long-rate-".concat(long, "-").concat(rate.coordinate, "-").concat(rate.rate), className: 'rate', style: {
                                left: "calc(".concat(rate.coordinate, "px - ").concat((((_a = document.getElementById("long-rate-".concat(long, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) / 2, "px)"),
                                bottom: "calc(".concat(timeScale === null || timeScale === void 0 ? void 0 : timeScale.height(), "px + 1.5em)"),
                                visibility: "".concat(((_b = document.getElementById("long-rate-".concat(long, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _b === void 0 ? void 0 : _b.clientWidth) ? 'visible' : 'hidden'),
                                color: themeStore.textColor
                            } }, { children: [shortExchanges[long], " ", rate.rate] })));
                    }), shortRates === null || shortRates === void 0 ? void 0 : shortRates.map(function (rate) {
                        var _a, _b;
                        return (jsxs("b", __assign({ id: "short-rate-".concat(short, "-").concat(rate.coordinate, "-").concat(rate.rate), className: 'rate', style: {
                                left: "calc(".concat(rate.coordinate, "px - ").concat((((_a = document.getElementById("short-rate-".concat(short, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) / 2, "px)"),
                                bottom: "calc(".concat(timeScale === null || timeScale === void 0 ? void 0 : timeScale.height(), "px + .5em)"),
                                visibility: "".concat(((_b = document.getElementById("short-rate-".concat(short, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _b === void 0 ? void 0 : _b.clientWidth) ? 'visible' : 'hidden'),
                                color: themeStore.textColor
                            } }, { children: [shortExchanges[short], " ", rate.rate] })));
                    })] }))] })));
});

var DefaultSocket = /** @class */ (function () {
    function DefaultSocket(options) {
        Object.defineProperty(this, "futuresReqInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotReqInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotMessagesCheckInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "futuresMessagesCheckInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onOrderbook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "divide", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ws", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "futuresUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noFuturesSocket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noSpotSocket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isClosedManually", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "messagesCheckInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3000
        });
        Object.defineProperty(this, "noMessagesAttempts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "futuresLastMessageTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotLastMessageTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "attempts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "retryIntervalMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1000
        });
        Object.defineProperty(this, "attemptsLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 5
        });
        Object.defineProperty(this, "maxConnectTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 10000
        });
        Object.defineProperty(this, "isFailedToConnect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasConnectionError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        var coin = options.coin, futuresUrl = options.futuresUrl, spotUrl = options.spotUrl, noFuturesSocket = options.noFuturesSocket, noSpotSocket = options.noSpotSocket, type = options.type, onOrderbook = options.onOrderbook, divide = options.divide, contractSize = options.contractSize;
        this.coin = coin;
        this.onOrderbook = onOrderbook;
        this.divide = divide;
        this.contractSize = contractSize;
        this.type = type;
        this.futuresUrl = futuresUrl;
        this.spotUrl = spotUrl;
        this.noFuturesSocket = noFuturesSocket;
        this.noSpotSocket = noSpotSocket;
        this.init();
    }
    Object.defineProperty(DefaultSocket.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (this.attempts > this.attemptsLimit ||
                this.noMessagesAttempts > this.attemptsLimit ||
                this.isFailedToConnect) {
                this.hasConnectionError = true;
                return;
            }
            var ws;
            switch (this.type) {
                case "futures": {
                    if (this.noFuturesSocket) {
                        this.futuresReqInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            var response, json, e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, fetch(this.futuresUrl)];
                                    case 1:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.json()];
                                    case 2:
                                        json = _a.sent();
                                        this.onFutures(json);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        e_1 = _a.sent();
                                        console.error(e_1);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, 500);
                        break;
                    }
                    ws = new WebSocket(this.futuresUrl);
                    this.ws = ws;
                    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (!this.futuresLastMessageTime) {
                                this.onFuturesClose();
                                if (!this.isClosedManually) {
                                    this.isFailedToConnect = true;
                                    this.close();
                                    this.init();
                                }
                            }
                            return [2 /*return*/];
                        });
                    }); }, this.maxConnectTime);
                    ws.onmessage = function (msg) { return _this.onFutures(msg); };
                    ws.onopen = function () {
                        _this.attempts = 0;
                        _this.futuresLastMessageTime = undefined;
                        _this.futuresMessagesCheckInterval = setInterval(function () {
                            if (!_this.futuresLastMessageTime)
                                return;
                            if (+new Date() - _this.futuresLastMessageTime > _this.messagesCheckInterval) {
                                _this.noMessagesAttempts += 1;
                                clearInterval(_this.futuresMessagesCheckInterval);
                                _this.close();
                                _this.init();
                            }
                        }, _this.messagesCheckInterval);
                        _this.onFuturesOpen();
                    };
                    ws.onclose = function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.onFuturesClose();
                                    if (!!this.isClosedManually) return [3 /*break*/, 2];
                                    this.attempts++;
                                    return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, _this.retryIntervalMs); })];
                                case 1:
                                    _a.sent();
                                    this.close();
                                    this.init();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                    break;
                }
                case "spot": {
                    if (this.noSpotSocket) {
                        this.spotReqInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            var response, json, e_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, fetch(this.spotUrl)];
                                    case 1:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.json()];
                                    case 2:
                                        json = _a.sent();
                                        this.onSpot(json);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        e_2 = _a.sent();
                                        console.error(e_2);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, 500);
                        break;
                    }
                    ws = new WebSocket(this.spotUrl);
                    this.ws = ws;
                    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (!this.spotLastMessageTime) {
                                this.onSpotClose();
                                if (!this.isClosedManually) {
                                    this.isFailedToConnect = true;
                                    this.close();
                                    this.init();
                                }
                            }
                            return [2 /*return*/];
                        });
                    }); }, this.maxConnectTime);
                    ws.onmessage = function (msg) { return _this.onSpot(msg); };
                    ws.onopen = function () {
                        _this.attempts = 0;
                        _this.spotLastMessageTime = undefined;
                        _this.spotMessagesCheckInterval = setInterval(function () {
                            if (!_this.spotLastMessageTime)
                                return;
                            if (+new Date() - _this.spotLastMessageTime > _this.messagesCheckInterval) {
                                _this.noMessagesAttempts += 1;
                                clearInterval(_this.spotLastMessageTime);
                                _this.close();
                                _this.init();
                            }
                        }, _this.messagesCheckInterval);
                        _this.onSpotOpen();
                    };
                    ws.onclose = function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.onSpotClose();
                                    if (!!this.isClosedManually) return [3 /*break*/, 2];
                                    this.attempts++;
                                    return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, _this.retryIntervalMs); })];
                                case 1:
                                    _a.sent();
                                    this.close();
                                    this.init();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                    break;
                }
            }
            this.isClosedManually = false;
        }
    });
    Object.defineProperty(DefaultSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            throw new Error("Not implemented");
        }
    });
    Object.defineProperty(DefaultSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) { throw new Error("Not implemented"); }
    });
    Object.defineProperty(DefaultSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) { throw new Error("Not implemented"); }
    });
    Object.defineProperty(DefaultSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "close", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            try {
                this.isClosedManually = true;
                if (((_a = this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1) {
                    (_b = this.ws) === null || _b === void 0 ? void 0 : _b.close();
                }
                clearInterval(this.futuresReqInterval);
                clearInterval(this.spotReqInterval);
                clearInterval(this.futuresMessagesCheckInterval);
                clearInterval(this.spotMessagesCheckInterval);
            }
            catch (e) {
            }
        }
    });
    return DefaultSocket;
}());

var ApexSocket = /** @class */ (function (_super) {
    __extends(ApexSocket, _super);
    function ApexSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://omni.apex.exchange/api/v3/depth?symbol=".concat(coin, "&limit=5");
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(ApexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new ApexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(ApexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            var mainData = message.data;
            var asks = mainData.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(ApexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
        }
    });
    return ApexSocket;
}(DefaultSocket));

var AsterSocket = /** @class */ (function (_super) {
    __extends(AsterSocket, _super);
    function AsterSocket(options) {
        var coin = options.coin;
        var futuresUrl = "wss://fstream.asterdex.com/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5@500ms");
        var spotUrl = "wss://sstream.asterdex.com/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5");
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(AsterSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new AsterSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(AsterSocket.prototype, "onError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(AsterSocket.prototype, "onOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(AsterSocket.prototype, "onClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(AsterSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            this.futuresLastMessageTime = +new Date();
            var message = JSON.parse(event.data);
            var asks = message.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(AsterSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            this.spotLastMessageTime = +new Date();
            var message = JSON.parse(event.data);
            var asks = message.a.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return AsterSocket;
}(DefaultSocket));

var BinanceSocket = /** @class */ (function (_super) {
    __extends(BinanceSocket, _super);
    function BinanceSocket(options) {
        var coin = options.coin;
        var futuresUrl = "wss://fstream.binance.com/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5@500ms");
        var spotUrl = "wss://stream.binance.com:9443/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5@1000ms");
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BinanceSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BinanceSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BinanceSocket.prototype, "onError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BinanceSocket.prototype, "onOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BinanceSocket.prototype, "onClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BinanceSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            this.futuresLastMessageTime = +new Date();
            var message = JSON.parse(event.data);
            var asks = message.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(BinanceSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            this.spotLastMessageTime = +new Date();
            var message = JSON.parse(event.data);
            var asks = message.asks.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.bids.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return BinanceSocket;
}(DefaultSocket));

var BingxSocket = /** @class */ (function (_super) {
    __extends(BingxSocket, _super);
    function BingxSocket(options) {
        var futuresUrl = "wss://open-api-swap.bingx.com/swap-market";
        var spotUrl = "wss://open-api-ws.bingx.com/market";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BingxSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BingxSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                reqType: "sub",
                dataType: "".concat(this.coin, "@depth5")
            }));
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                id: v4(),
                reqType: "sub",
                dataType: "".concat(this.coin, "@depth5")
            }));
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, data, dataType, asks, bids;
                var _this = this;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            this.futuresLastMessageTime = +new Date();
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, message.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            if (decodedMsg === "Ping") {
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send('Pong');
                                return [2 /*return*/];
                            }
                            _d = JSON.parse(decodedMsg), data = _d.data, dataType = _d.dataType;
                            if (dataType === null || dataType === void 0 ? void 0 : dataType.includes("@depth5")) {
                                asks = data.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); }).reverse();
                                bids = data.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, ping, time, data, dataType, objString, asks, bids;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            this.spotLastMessageTime = +new Date();
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, message.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            _d = JSON.parse(decodedMsg), ping = _d.ping, time = _d.time, data = _d.data, dataType = _d.dataType;
                            if (ping) {
                                objString = JSON.stringify({ pong: ping, time: time });
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(objString);
                                return [2 /*return*/];
                            }
                            if (dataType === null || dataType === void 0 ? void 0 : dataType.includes("@depth5")) {
                                asks = data.asks.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); }).reverse();
                                bids = data.bids.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    return BingxSocket;
}(DefaultSocket));

var BitgetSocket = /** @class */ (function (_super) {
    __extends(BitgetSocket, _super);
    function BitgetSocket(options) {
        var _this = this;
        var futuresUrl = "wss://ws.bitget.com/v2/ws/public";
        var spotUrl = "wss://ws.bitget.com/v2/ws/public";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(BitgetSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BitgetSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b;
            var val = {
                "instType": "USDT-FUTURES",
                "channel": "books5",
                "instId": (_a = this.coin) === null || _a === void 0 ? void 0 : _a.replace("_UMCBL", "")
            };
            (_b = this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                "op": "subscribe",
                "args": [val]
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 5000);
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var val = {
                "instType": "SPOT",
                "channel": "books5",
                "instId": this.coin,
            };
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [val]
            }));
            this.spotInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 5000);
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            if (event.data === 'pong')
                return;
            this.futuresLastMessageTime = +new Date();
            var _a = JSON.parse(event.data), action = _a.action, data = _a.data;
            if (action === "snapshot") {
                var mainData = data[0];
                var asks = mainData.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = mainData.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, action, data, mainData, asks, bids;
                var _this = this;
                return __generator(this, function (_b) {
                    if (event.data === 'pong')
                        return [2 /*return*/];
                    this.spotLastMessageTime = +new Date();
                    _a = JSON.parse(event.data), action = _a.action, data = _a.data;
                    if (action === "snapshot") {
                        mainData = data[0];
                        asks = mainData.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                        bids = mainData.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                        this.onOrderbook({ asks: asks, bids: bids });
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return BitgetSocket;
}(DefaultSocket));

var BitmartSocket = /** @class */ (function (_super) {
    __extends(BitmartSocket, _super);
    function BitmartSocket(options) {
        var _this = this;
        var futuresUrl = "wss://contract-ws-v2.bitmart.com/v1/ifcontract/realTime";
        var spotUrl = "wss://ws-manager-compress.bitmart.com/api?protocol=1.1";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(BitmartSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BitmartSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "action": "subscribe",
                "args": ["Depth:".concat(this.coin)]
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "action": "ping" })); }, 10 * 1000);
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var index = 0; // ???
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": ["spot/depth5:".concat(this.coin)]
            }));
            this.spotInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, (5 + index) * 1000);
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d;
            this.futuresLastMessageTime = +new Date();
            var eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (_e) {
                return;
            }
            var action = eventData.action, group = eventData.group, data = eventData.data;
            if (!action && (group === null || group === void 0 ? void 0 : group.includes("Depth:"))) {
                var mainData = data[0] || data;
                if ((mainData === null || mainData === void 0 ? void 0 : mainData.way) === 1) {
                    var bids = (_b = (_a = mainData === null || mainData === void 0 ? void 0 : mainData.depths) === null || _a === void 0 ? void 0 : _a.slice(0, 5)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.price / _this.divide, volume: (item.price * item.vol * _this.contractSize).toFixed(2) }); });
                    if (!(bids === null || bids === void 0 ? void 0 : bids.length))
                        return;
                    this.onOrderbook({ bids: bids });
                }
                if ((mainData === null || mainData === void 0 ? void 0 : mainData.way) === 2) {
                    var asks = (_d = (_c = mainData === null || mainData === void 0 ? void 0 : mainData.depths) === null || _c === void 0 ? void 0 : _c.slice(0, 5)) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item.price / _this.divide, volume: (item.price * item.vol * _this.contractSize).toFixed(2) }); });
                    if (!(asks === null || asks === void 0 ? void 0 : asks.length))
                        return;
                    this.onOrderbook({ asks: asks });
                }
            }
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            this.spotLastMessageTime = +new Date();
            var eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (_a) {
                return;
            }
            var table = eventData.table, data = eventData.data;
            if (table) {
                var mainData = data[0] || data;
                var asks = mainData.asks.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = mainData.bids.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return BitmartSocket;
}(DefaultSocket));

var BitmexSocket = /** @class */ (function (_super) {
    __extends(BitmexSocket, _super);
    function BitmexSocket(options) {
        var futuresUrl = "wss://ws.bitmex.com/realtime";
        var spotUrl = "wss://ws.bitmex.com/realtime";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BitmexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BitmexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": ["orderBook10:".concat(this.coin)]
            }));
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            var arr = ["orderBook10:".concat(this.coin)];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": arr
            }));
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            this.futuresLastMessageTime = +new Date();
            var _a = JSON.parse(event.data), action = _a.action, table = _a.table, data = _a.data;
            if (action && table) {
                var mainData = data[0] || data;
                var asks = mainData.asks.slice(0, 5).map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                var bids = mainData.bids.slice(0, 5).map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            this.spotLastMessageTime = +new Date();
            var _a = JSON.parse(event.data), action = _a.action, table = _a.table, data = _a.data;
            if (action && table) {
                var mainData = data[0] || data;
                var asks = mainData.asks.slice(0, 5).map(function (item) { return ({ price: item[0], volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                var bids = mainData.bids.slice(0, 5).map(function (item) { return ({ price: item[0], volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    return BitmexSocket;
}(DefaultSocket));

var BlofinSocket = /** @class */ (function (_super) {
    __extends(BlofinSocket, _super);
    function BlofinSocket(options) {
        var _this = this;
        var futuresUrl = "wss://openapi.blofin.com/ws/public";
        var spotUrl = "";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(BlofinSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BlofinSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var val = {
                "channel": "books5",
                "instId": this.coin
            };
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [val]
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 5000);
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BlofinSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            if (event.data === 'pong')
                return;
            this.futuresLastMessageTime = +new Date();
            var _a = JSON.parse(event.data), action = _a.action, data = _a.data;
            if (action === "snapshot") {
                var mainData = data;
                var asks = mainData.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = mainData.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/];
            }); });
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return BlofinSocket;
}(DefaultSocket));

var BybitSocket = /** @class */ (function (_super) {
    __extends(BybitSocket, _super);
    function BybitSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://api.bybit.com/v5/market/orderbook?category=linear&symbol=".concat(coin, "&limit=5");
        var spotUrl = "https://api.bybit.com/v5/market/orderbook?category=spot&symbol=".concat(coin, "&limit=5");
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(BybitSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BybitSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BybitSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            var mainData = message.result;
            var asks = mainData.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(BybitSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            var mainData = message.result;
            var asks = mainData.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return BybitSocket;
}(DefaultSocket));

var CoinexSocket = /** @class */ (function (_super) {
    __extends(CoinexSocket, _super);
    function CoinexSocket(options) {
        var _this = this;
        var futuresUrl = "wss://socket.coinex.com/v2/futures/";
        var spotUrl = "wss://socket.coinex.com/v2/spot";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(CoinexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new CoinexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, 5, '0', true];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "depth.subscribe",
                "params": { market_list: [params] },
                "id": 42
            }));
            this.futuresInterval = setInterval(function () {
                var _a;
                return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                    "method": "server.ping",
                    "params": {},
                    "id": 42
                }));
            }, 2000);
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, 5, '0', true];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "depth.subscribe",
                "params": { market_list: [params] },
                "id": 42
            }));
            this.spotInterval = setInterval(function () {
                var _a;
                return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                    "method": "server.ping",
                    "params": {},
                    "id": 42
                }));
            }, 2000);
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var buf, _c, _d, decodedMsg, _e, data, method, asks, bids;
                var _this = this;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            this.futuresLastMessageTime = +new Date();
                            _d = (_c = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buf = _d.apply(_c, [_f.sent()]);
                            decodedMsg = zlib.gunzipSync(buf).toString('utf-8');
                            _e = JSON.parse(decodedMsg), data = _e.data, method = _e.method;
                            if (method === "depth.update") {
                                asks = (_a = data === null || data === void 0 ? void 0 : data.depth) === null || _a === void 0 ? void 0 : _a.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                bids = (_b = data === null || data === void 0 ? void 0 : data.depth) === null || _b === void 0 ? void 0 : _b.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function () {
                var buf, _e, _f, decodedMsg, _g, data, method, asks, bids;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            this.spotLastMessageTime = +new Date();
                            _f = (_e = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buf = _f.apply(_e, [_h.sent()]);
                            decodedMsg = zlib.gunzipSync(buf).toString('utf-8');
                            _g = JSON.parse(decodedMsg), data = _g.data, method = _g.method;
                            if (method === "depth.update") {
                                asks = (_b = (_a = data === null || data === void 0 ? void 0 : data.depth) === null || _a === void 0 ? void 0 : _a.asks) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                                bids = (_d = (_c = data === null || data === void 0 ? void 0 : data.depth) === null || _c === void 0 ? void 0 : _c.bids) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return CoinexSocket;
}(DefaultSocket));

var GateioSocket = /** @class */ (function (_super) {
    __extends(GateioSocket, _super);
    function GateioSocket(options) {
        var _this = this;
        var futuresUrl = "wss://fx-ws.gateio.ws/v4/ws/usdt";
        var spotUrl = "wss://ws.gate.io/v3/";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(GateioSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new GateioSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, '5', "0"];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "channel": "futures.order_book",
                "event": "subscribe",
                "payload": [params]
            }));
            if (this.futuresInterval)
                clearInterval(this.futuresInterval);
            this.futuresInterval = setInterval(function () {
                var _a;
                try {
                    (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "time": Math.floor(+new Date() / 1000), "channel": "futures.ping" }));
                }
                catch (e) {
                    // this.onFuturesClose()
                }
            }, 5000);
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, 5, "0"];
            var payload = JSON.stringify({
                "id": 42,
                "method": "depth.subscribe",
                "params": [params]
            });
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(payload);
            if (this.spotInterval)
                clearInterval(this.spotInterval);
            this.spotInterval = setInterval(function () {
                var _a;
                try {
                    (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "id": 42, "method": "server.ping", "params": [] }));
                }
                catch (e) {
                    // this.onSpotClose()
                }
            }, 5000);
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            this.futuresLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), error = _c.error, result = _c.result, channel = _c.channel;
            if (error === null || error === void 0 ? void 0 : error.code) {
                return;
            }
            if (channel === "futures.order_book" && result.asks && result.bids) {
                var asks = ((_a = result.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item.p, volume: (item.s * item.p * _this.contractSize).toFixed(2) }); })) || [];
                var bids = ((_b = result.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.p, volume: (item.s * item.p * _this.contractSize).toFixed(2) }); })) || [];
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d, _e, _f;
            this.spotLastMessageTime = +new Date();
            var _g = JSON.parse(event.data), error = _g.error, method = _g.method, params = _g.params;
            if (error === null || error === void 0 ? void 0 : error.code) {
                return;
            }
            if (method === "depth.update" && ((_a = params === null || params === void 0 ? void 0 : params.at(1)) === null || _a === void 0 ? void 0 : _a.asks) && ((_b = params === null || params === void 0 ? void 0 : params.at(1)) === null || _b === void 0 ? void 0 : _b.bids)) {
                var asks = ((_d = (_c = params === null || params === void 0 ? void 0 : params.at(1)) === null || _c === void 0 ? void 0 : _c.asks) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); })) || [];
                var bids = ((_f = (_e = params === null || params === void 0 ? void 0 : params.at(1)) === null || _e === void 0 ? void 0 : _e.bids) === null || _f === void 0 ? void 0 : _f.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); })) || [];
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return GateioSocket;
}(DefaultSocket));

var HuobiSocket = /** @class */ (function (_super) {
    __extends(HuobiSocket, _super);
    function HuobiSocket(options) {
        var futuresUrl = "wss://api.hbdm.com/linear-swap-ws";
        var spotUrl = "wss://api.huobi.pro/ws";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(HuobiSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new HuobiSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "sub": "market.".concat(this.coin, ".depth.step0"),
                "id": "331"
            }));
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "sub": "market.".concat(this.coin, ".depth.step0"),
                "id": "631"
            }));
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, ch, ping, tick, iterArr, asks, bids;
                var _this = this;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            this.futuresLastMessageTime = +new Date();
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            _d = JSON.parse(decodedMsg), ch = _d.ch, ping = _d.ping, tick = _d.tick;
                            if (ch === null || ch === void 0 ? void 0 : ch.includes("market")) {
                                iterArr = Array(5).fill(Number);
                                asks = iterArr.map(function (_, index) {
                                    var item = tick.asks[index];
                                    return { price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) };
                                });
                                bids = iterArr.map(function (_, index) {
                                    var item = tick.bids[index];
                                    return { price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) };
                                });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            if (ping) {
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ pong: ping }));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, ch, ping, tick, iterArr, asks, bids;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            this.spotLastMessageTime = +new Date();
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            _d = JSON.parse(decodedMsg), ch = _d.ch, ping = _d.ping, tick = _d.tick;
                            if (ch === null || ch === void 0 ? void 0 : ch.includes("market")) {
                                iterArr = Array(5).fill(Number);
                                asks = iterArr.map(function (_, index) {
                                    var _a;
                                    var item = (_a = tick.asks) === null || _a === void 0 ? void 0 : _a[index];
                                    return { price: item[0], volume: (item[1] * item[0]).toFixed(2) };
                                });
                                bids = iterArr.map(function (_, index) {
                                    var _a;
                                    var item = (_a = tick.bids) === null || _a === void 0 ? void 0 : _a[index];
                                    return { price: item[0], volume: (item[1] * item[0]).toFixed(2) };
                                });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            if (ping) {
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ pong: ping }));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    return HuobiSocket;
}(DefaultSocket));

var HyperLiquidSocket = /** @class */ (function (_super) {
    __extends(HyperLiquidSocket, _super);
    function HyperLiquidSocket(options) {
        var _this = this;
        var futuresUrl = "wss://api.hyperliquid.xyz/ws";
        var spotUrl = "wss://api.hyperliquid.xyz/ws";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "coin1", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "coin2", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(HyperLiquidSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new HyperLiquidSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            var _b;
            if (!this.coin) {
                return;
            }
            _a = this.coin.split(' '), this.coin1 = _a[0], this.coin2 = _a[1];
            (_b = this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                "method": "subscribe",
                "subscription": { "type": "l2Book", "coin": this.coin }
            }));
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "subscribe",
                "subscription": { "type": "l2Book", "coin": this.coin }
            }));
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c;
            this.futuresLastMessageTime = +new Date();
            var _d = JSON.parse(event.data), channel = _d.channel, data = _d.data;
            var divide = ((_a = this.coin) === null || _a === void 0 ? void 0 : _a.at(0)) === 'k' ? 1000 : 1;
            if (channel === "l2Book") {
                var asks = (_b = data.levels.at(1)) === null || _b === void 0 ? void 0 : _b.slice(0, 5).map(function (item) { return ({ price: item.px / divide, volume: (item.px * item.sz).toFixed(2) }); });
                var bids = (_c = data.levels.at(0)) === null || _c === void 0 ? void 0 : _c.slice(0, 5).map(function (item) { return ({ price: item.px / divide, volume: (item.px * item.sz).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            this.spotLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), channel = _c.channel, data = _c.data;
            if (channel === "l2Book") {
                var asks = (_a = data.levels.at(1)) === null || _a === void 0 ? void 0 : _a.slice(0, 5).map(function (item) { return ({ price: item.px, volume: (item.px * item.sz).toFixed(2) }); });
                var bids = (_b = data.levels.at(0)) === null || _b === void 0 ? void 0 : _b.slice(0, 5).map(function (item) { return ({ price: item.px, volume: (item.px * item.sz).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    return HyperLiquidSocket;
}(DefaultSocket));

var KucoinSocket = /** @class */ (function (_super) {
    __extends(KucoinSocket, _super);
    function KucoinSocket(options) {
        var _this = this;
        var futuresToken = options.futuresToken, spotToken = options.spotToken;
        var futuresUrl = "wss://ws-api-futures.kucoin.com/endpoint?token=".concat(futuresToken);
        var spotUrl = "wss://ws-api-spot.kucoin.com/endpoint?token=".concat(spotToken);
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "spotToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "futuresToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.spotToken = spotToken;
        _this.futuresToken = futuresToken;
        return _this;
    }
    Object.defineProperty(KucoinSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var futuresToken, spotToken, baseUrl_1, futuresResposne, token, baseUrl_2, spotResponse, token;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, userStore.getBaseUrl()];
                        case 1:
                            baseUrl_1 = _a.sent();
                            return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _a, _b;
                                    var _c;
                                    return __generator(this, function (_d) {
                                        switch (_d.label) {
                                            case 0:
                                                _a = fetch;
                                                _b = ["".concat(baseUrl_1, "/kucoin/futures")];
                                                _c = {};
                                                return [4 /*yield*/, getHeaders()];
                                            case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                        _c)]))];
                                            case 2: return [2 /*return*/, _d.sent()];
                                        }
                                    });
                                }); })];
                        case 2:
                            futuresResposne = _a.sent();
                            return [4 /*yield*/, futuresResposne.json()];
                        case 3:
                            token = (_a.sent()).token;
                            if (token) {
                                localStorage.setItem('kucoin:futures:token', token);
                                futuresToken = token;
                            }
                            else {
                                futuresToken = localStorage.getItem('kucoin:futures:token');
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 5:
                            _a.trys.push([5, 9, , 10]);
                            return [4 /*yield*/, userStore.getBaseUrl()];
                        case 6:
                            baseUrl_2 = _a.sent();
                            return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _a, _b;
                                    var _c;
                                    return __generator(this, function (_d) {
                                        switch (_d.label) {
                                            case 0:
                                                _a = fetch;
                                                _b = ["".concat(baseUrl_2, "/kucoin/spot")];
                                                _c = {};
                                                return [4 /*yield*/, getHeaders()];
                                            case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                        _c)]))];
                                            case 2: return [2 /*return*/, _d.sent()];
                                        }
                                    });
                                }); })];
                        case 7:
                            spotResponse = _a.sent();
                            return [4 /*yield*/, spotResponse.json()];
                        case 8:
                            token = (_a.sent()).token;
                            if (token) {
                                localStorage.setItem('kucoin:spot:token', token);
                                spotToken = token;
                            }
                            else {
                                spotToken = localStorage.getItem('kucoin:spot:token');
                            }
                            return [3 /*break*/, 10];
                        case 9:
                            _a.sent();
                            return [3 /*break*/, 10];
                        case 10: return [2 /*return*/, new KucoinSocket(__assign(__assign({}, options), { futuresToken: futuresToken, spotToken: spotToken }))];
                    }
                });
            });
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "type": "subscribe",
                "topic": "/contractMarket/level2Depth5:".concat(this.coin)
            }));
            this.futuresInterval = setInterval(function () {
                var _a;
                return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                    id: _this.futuresToken,
                    type: "ping"
                }));
            }, 5000);
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                id: this.spotToken,
                "type": "subscribe",
                "topic": "/spotMarket/level2Depth5:".concat(this.coin)
            }));
            this.spotInterval = setInterval(function () {
                var _a;
                return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                    id: _this.spotToken,
                    type: "ping"
                }));
            }, 5000);
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            this.futuresLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), subject = _c.subject, data = _c.data;
            if (subject === null || subject === void 0 ? void 0 : subject.includes("level2")) {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            this.spotLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), subject = _c.subject, id = _c.id, type = _c.type, data = _c.data;
            if (subject === null || subject === void 0 ? void 0 : subject.includes("level2")) {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
            else if (id && type == 'welcome') {
                clearInterval(this.spotInterval);
                this.spotInterval = setInterval(function () {
                    var _a;
                    (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                        id: id,
                        type: "ping"
                    }));
                }, 2000);
            }
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    return KucoinSocket;
}(DefaultSocket));

var LighterSocket = /** @class */ (function (_super) {
    __extends(LighterSocket, _super);
    function LighterSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://mainnet.zklighter.elliot.ai/api/v1/orderBookOrders?market_id=".concat(coin, "&limit=100");
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(LighterSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new LighterSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(LighterSocket.prototype, "onError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(LighterSocket.prototype, "onOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(LighterSocket.prototype, "onClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(LighterSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            this.futuresLastMessageTime = +new Date();
            console.log(message);
            var asksObj = {};
            var bidsObj = {};
            var asksResLength = 0;
            var bidsResLength = 0;
            var asksIndex = 0;
            var bidsIndex = 0;
            var asksLength = message.asks.length;
            var bidsLength = message.bids.length;
            while (asksIndex < asksLength) {
                var item = message.asks[asksIndex];
                if (!asksObj[item.price]) {
                    asksResLength += 1;
                    if (asksResLength > 5)
                        break;
                    asksObj[item.price] = +item.remaining_base_amount;
                }
                else
                    asksObj[item.price] += +item.remaining_base_amount;
                asksIndex += 1;
            }
            while (bidsIndex < bidsLength) {
                var item = message.bids[bidsIndex];
                if (!bidsObj[item.price]) {
                    bidsResLength += 1;
                    if (bidsResLength > 5)
                        break;
                    bidsObj[item.price] = +item.remaining_base_amount;
                }
                else
                    bidsObj[item.price] += +item.remaining_base_amount;
                bidsIndex += 1;
            }
            var asks = Object.keys(asksObj).map(function (key) { return ({ price: +key, volume: (+key * asksObj[key]).toFixed(2) }); });
            var bids = Object.keys(bidsObj).map(function (key) { return ({ price: +key, volume: (+key * bidsObj[key]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(LighterSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
        }
    });
    return LighterSocket;
}(DefaultSocket));

var MexcSocket = /** @class */ (function (_super) {
    __extends(MexcSocket, _super);
    function MexcSocket(options) {
        var _this = this;
        var futuresUrl = "wss://contract.mexc.co/edge";
        var spotUrl = "wss://wbs.mexc.co/ws";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(MexcSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new MexcSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "sub.depth.full",
                "param": {
                    "symbol": this.coin,
                    "limit": 5
                }
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "method": "ping" })); }, 10000);
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "SUBSCRIPTION",
                "params": ["spot@public.limit.depth.v3.api@".concat(this.coin, "@").concat(5)]
            }));
            this.spotInterval = setInterval(function () { var _a; (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "method": "PING" })); }, 5000);
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            this.futuresLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), channel = _c.channel, data = _c.data;
            if (channel === "push.depth.full") {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            this.spotLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), s = _c.s, d = _c.d;
            if (s) {
                var asks = (_a = d === null || d === void 0 ? void 0 : d.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item.p, volume: (item.p * item.v).toFixed(2) }); });
                var bids = (_b = d === null || d === void 0 ? void 0 : d.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.p, volume: (item.p * item.v).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return MexcSocket;
}(DefaultSocket));

var OkxSocket = /** @class */ (function (_super) {
    __extends(OkxSocket, _super);
    function OkxSocket(options) {
        var _this = this;
        var futuresUrl = "wss://ws.okx.com:8443/ws/v5/public";
        var spotUrl = "wss://ws.okx.com:8443/ws/v5/public";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(OkxSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new OkxSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [
                    {
                        "channel": "books5",
                        "instId": this.coin
                    }
                ]
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 1000);
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [
                    {
                        "channel": "books5",
                        "instId": this.coin
                    }
                ]
            }));
            this.spotInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 1000);
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d, _e;
            if (event.data === 'pong') {
                return;
            }
            this.futuresLastMessageTime = +new Date();
            var data = JSON.parse(event.data).data;
            if ((_a = data === null || data === void 0 ? void 0 : data.at(0)) === null || _a === void 0 ? void 0 : _a.asks) {
                var asks = (_c = (_b = data === null || data === void 0 ? void 0 : data.at(0)) === null || _b === void 0 ? void 0 : _b.asks) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_e = (_d = data === null || data === void 0 ? void 0 : data.at(0)) === null || _d === void 0 ? void 0 : _d.bids) === null || _e === void 0 ? void 0 : _e.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d, _e;
            this.spotLastMessageTime = +new Date();
            var data = JSON.parse(event.data).data;
            if ((_a = data === null || data === void 0 ? void 0 : data.at(0)) === null || _a === void 0 ? void 0 : _a.asks) {
                var asks = (_c = (_b = data === null || data === void 0 ? void 0 : data.at(0)) === null || _b === void 0 ? void 0 : _b.asks) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_e = (_d = data === null || data === void 0 ? void 0 : data.at(0)) === null || _d === void 0 ? void 0 : _d.bids) === null || _e === void 0 ? void 0 : _e.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return OkxSocket;
}(DefaultSocket));

var OurbitSocket = /** @class */ (function (_super) {
    __extends(OurbitSocket, _super);
    function OurbitSocket(options) {
        var _this = this;
        var futuresUrl = "wss://futures.ourbit.com/edge";
        var spotUrl = "wss://wbs.ourbit.com/ws";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(OurbitSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new OurbitSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "sub.depth.step",
                "param": {
                    "symbol": this.coin,
                    "limit": 5
                }
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "method": "ping" })); }, 5000);
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "SUBSCRIPTION",
                "params": ["spot@public.limit.depth.v3.api@".concat(this.coin, "@5")]
            }));
            this.spotInterval = setInterval(function () { var _a; (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ "method": "PING" })); }, 5000);
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d;
            this.futuresLastMessageTime = +new Date();
            var _e = JSON.parse(event.data), channel = _e.channel, data = _e.data;
            if (channel === "push.depth.step") {
                var asks = (_b = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.slice(0, 5)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_d = (_c = data === null || data === void 0 ? void 0 : data.bids) === null || _c === void 0 ? void 0 : _c.slice(0, 5)) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            this.spotLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), s = _c.s, d = _c.d;
            if (s) {
                var asks = (_a = d === null || d === void 0 ? void 0 : d.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item.p, volume: (item.p * item.v).toFixed(2) }); });
                var bids = (_b = d === null || d === void 0 ? void 0 : d.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.p, volume: (item.p * item.v).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return OurbitSocket;
}(DefaultSocket));

var ParadexSocket = /** @class */ (function (_super) {
    __extends(ParadexSocket, _super);
    function ParadexSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://api.prod.paradex.trade/v1/orderbook/".concat(coin, "?depth=5");
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(ParadexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new ParadexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(ParadexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _a, _b;
            var mainData = message;
            // @ts-ignore
            var divide = +((_b = (_a = mainData === null || mainData === void 0 ? void 0 : mainData.symbol) === null || _a === void 0 ? void 0 : _a.match(/^\d*/g)) === null || _b === void 0 ? void 0 : _b.at(0)) || 1;
            var asks = mainData.asks.slice(0, 5).map(function (item) { return ({ price: item[0] / divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.bids.slice(0, 5).map(function (item) { return ({ price: item[0] / divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return ParadexSocket;
}(DefaultSocket));

var depth = 5;
var XtSocket = /** @class */ (function (_super) {
    __extends(XtSocket, _super);
    function XtSocket(options) {
        var _this = this;
        var futuresUrl = "wss://fstream.xt.com/ws/market";
        var spotUrl = "wss://stream.xt.com/public";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(XtSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new XtSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(XtSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "subscribe",
                "params": ["depth@".concat(this.coin, ",").concat(depth)],
                "id": v4()
            }));
            this.futuresInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 10000);
        }
    });
    Object.defineProperty(XtSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "subscribe",
                "params": ["depth@".concat(this.coin, ",").concat(depth)],
                "id": v4()
            }));
            this.spotInterval = setInterval(function () { var _a; return (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send('ping'); }, 10000);
        }
    });
    Object.defineProperty(XtSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            if (event.data === 'pong') {
                return;
            }
            this.futuresLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), topic = _c.topic, data = _c.data;
            if (topic === "depth") {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.a) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.b) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(XtSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            if (event.data === 'pong') {
                return;
            }
            this.spotLastMessageTime = +new Date();
            var _c = JSON.parse(event.data), topic = _c.topic, data = _c.data;
            if (topic === "depth") {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.a) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.b) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(XtSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(XtSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return XtSocket;
}(DefaultSocket));

var socketFactoriesMap = {
    "binance": BinanceSocket.factory,
    "bingx": BingxSocket.factory,
    "bitget": BitgetSocket.factory,
    "bitmart": BitmartSocket.factory,
    "bitmex": BitmexSocket.factory,
    "bybit": BybitSocket.factory,
    "coinex": CoinexSocket.factory,
    "gateio": GateioSocket.factory,
    "huobi": HuobiSocket.factory,
    "hyper": HyperLiquidSocket.factory,
    "kucoin": KucoinSocket.factory,
    // "lbank": LbankSocket.factory, // not work
    "mexc": MexcSocket.factory,
    "okx": OkxSocket.factory,
    'xt': XtSocket.factory,
    'ourbit': OurbitSocket.factory,
    'blofin': BlofinSocket.factory,
    'paradex': ParadexSocket.factory,
    'aster': AsterSocket.factory,
    'lighter': LighterSocket.factory,
    'apex': ApexSocket.factory
    // 'phemex': PhemexSocket.factory
};
function createSocketConnection(options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var long, short, longCoin, shortCoin, type, onLongOrderbook, onShortOrderbook, longContractSize, shortContractSize, createLongSocket, createShortSocket, divideLong, divideShort, _c, longType, shortType, longSocket, shortSocket;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    long = options.long, short = options.short, longCoin = options.longCoin, shortCoin = options.shortCoin, type = options.type, onLongOrderbook = options.onLongOrderbook, onShortOrderbook = options.onShortOrderbook, longContractSize = options.longContractSize, shortContractSize = options.shortContractSize;
                    createLongSocket = socketFactoriesMap[long || ''];
                    createShortSocket = socketFactoriesMap[short || ''];
                    divideLong = (long !== 'bitmart') ? (+((_a = longCoin === null || longCoin === void 0 ? void 0 : longCoin.match(/^10+/g)) === null || _a === void 0 ? void 0 : _a.at(0)) || 1) : 1;
                    divideShort = (short !== 'bitmart') ? (+((_b = shortCoin === null || shortCoin === void 0 ? void 0 : shortCoin.match(/^10+/g)) === null || _b === void 0 ? void 0 : _b.at(0)) || 1) : 1;
                    _c = getTypes(type), longType = _c.longType, shortType = _c.shortType;
                    return [4 /*yield*/, (createLongSocket === null || createLongSocket === void 0 ? void 0 : createLongSocket({ type: longType, coin: longCoin, onOrderbook: onLongOrderbook, divide: divideLong, contractSize: longContractSize }))];
                case 1:
                    longSocket = _d.sent();
                    return [4 /*yield*/, (createShortSocket === null || createShortSocket === void 0 ? void 0 : createShortSocket({ type: shortType, coin: shortCoin, onOrderbook: onShortOrderbook, divide: divideShort, contractSize: shortContractSize }))];
                case 2:
                    shortSocket = _d.sent();
                    return [2 /*return*/, {
                            close: function () {
                                longSocket === null || longSocket === void 0 ? void 0 : longSocket.close();
                                shortSocket === null || shortSocket === void 0 ? void 0 : shortSocket.close();
                            },
                            checkErrors: {
                                checkLong: function () { var _a; return (_a = longSocket === null || longSocket === void 0 ? void 0 : longSocket.hasConnectionError) !== null && _a !== void 0 ? _a : true; },
                                checkShort: function () { var _a; return (_a = shortSocket === null || shortSocket === void 0 ? void 0 : shortSocket.hasConnectionError) !== null && _a !== void 0 ? _a : true; }
                            }
                        }];
            }
        });
    });
}
function getTypes(type) {
    var longType = "futures";
    var shortType = "futures";
    if (type === "spot") {
        longType = "spot";
    }
    if (type === 'margin') {
        shortType = "spot";
    }
    return { longType: longType, shortType: shortType };
}

function getFuturesMarketCoins() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, markstesMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/market-coins/futures"))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    markstesMap = _a.sent();
                    return [2 /*return*/, markstesMap];
            }
        });
    });
}
function getSpotMarketCoins() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, markstesMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/market-coins/spot"))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    markstesMap = _a.sent();
                    return [2 /*return*/, markstesMap];
            }
        });
    });
}
function getContractSizes() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractsMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/contract-sizes"))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractsMap = _a.sent();
                    return [2 /*return*/, contractsMap];
            }
        });
    });
}
function getBitmexSpotContractSize(coin) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/bitmex/contract-size/spot/").concat(coin))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractSize = _a.sent();
                    return [2 /*return*/, contractSize];
            }
        });
    });
}
function getPhemexSpotContractSize(coin) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/phemex/contract-size/spot/").concat(coin))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractSize = _a.sent();
                    return [2 /*return*/, contractSize];
            }
        });
    });
}
function getLighterDivides(coin) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/lighter/divides/").concat(coin))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractSize = _a.sent();
                    return [2 /*return*/, contractSize];
            }
        });
    });
}

function useGetCoinForMarket(type, market, backendCoin) {
    var _this = this;
    var marketsKoinsMap = useQuery({
        queryKey: ['MarketsCoinsMap', type],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === "spot")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getSpotMarketCoins()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, getFuturesMarketCoins()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        }); }
    }).data;
    var coin = useMemo(function () {
        var _a;
        if (!market) {
            return undefined;
        }
        var coins = marketsKoinsMap === null || marketsKoinsMap === void 0 ? void 0 : marketsKoinsMap[market];
        return (_a = coins === null || coins === void 0 ? void 0 : coins.find(function (_a) {
            var a = _a[0]; _a[1];
            return a === backendCoin;
        })) === null || _a === void 0 ? void 0 : _a[1];
    }, [market, backendCoin, marketsKoinsMap]);
    return coin;
}

function useGetContractSize(type, market, backendCoin) {
    var _this = this;
    var contractsMap = useQuery({
        queryKey: ['ContractSizesMap'],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getContractSizes()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); }
    }).data;
    var contractSize = useMemo(function () {
        if (!market) {
            return 0;
        }
        var contracts = contractsMap === null || contractsMap === void 0 ? void 0 : contractsMap[market];
        return +(contracts === null || contracts === void 0 ? void 0 : contracts[backendCoin]) || 0; //parseInt(contracts?.[backendCoin], 10)
    }, [market, backendCoin, contractsMap]);
    var bitmexSpotContractSize = useQuery({
        queryKey: ['BitmexContractSize', type, backendCoin, market],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var contract_size;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === "spot" && market === "bitmex")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getBitmexSpotContractSize(backendCoin)];
                    case 1:
                        contract_size = (_a.sent()).contract_size;
                        return [2 /*return*/, parseInt(contract_size, 10)];
                    case 2: return [2 /*return*/, 1];
                }
            });
        }); }
    }).data;
    var phemexSpotContractSize = useQuery({
        queryKey: ['PhemexContractSize', type, backendCoin, market],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var contract_size;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === "spot" && market === "phemex")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPhemexSpotContractSize(backendCoin)];
                    case 1:
                        contract_size = (_a.sent()).contract_size;
                        return [2 /*return*/, contract_size];
                    case 2: return [2 /*return*/, 1];
                }
            });
        }); }
    }).data;
    var lighterDivides = useQuery({
        queryKey: ['LighterDivides', type, backendCoin, market],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var divide;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(market === "lighter")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getLighterDivides(backendCoin)];
                    case 1:
                        divide = (_a.sent()).divide;
                        return [2 /*return*/, divide];
                    case 2: return [2 /*return*/, 1];
                }
            });
        }); }
    }).data;
    if (type === "spot" && market === "bitmex") {
        return bitmexSpotContractSize || 1;
    }
    if (type === "spot" && market === "phemex") {
        return phemexSpotContractSize || 1;
    }
    if (market === 'lighter') {
        return lighterDivides || 1;
    }
    if (contractsMap && !contractSize) {
        return 1;
    }
    return contractSize;
}

var Graph = observer(function (_a) {
    var type = _a.type, coin = _a.coin, long = _a.long, short = _a.short, chain = _a.chain, isVisible = _a.isVisible, UpperInfo = _a.UpperInfo, LowerInfo = _a.LowerInfo;
    var _b = useState(), statistics = _b[0], setStatistics = _b[1];
    var _c = useState(chartStore.timeFrames[0]), timeFrame = _c[0], setTimeFrame = _c[1];
    var _d = useState(false), waitingToReconnect = _d[0], setWaitingToReconnect = _d[1];
    var clientRef = useRef(null);
    var _e = getTypes(type), longType = _e.longType, shortType = _e.shortType;
    var longCoin = useGetCoinForMarket(longType, long, coin);
    var shortCoin = useGetCoinForMarket(shortType, short, coin);
    var longContractSize = useGetContractSize(longType, long, coin);
    var shortContractSize = useGetContractSize(shortType, short, coin);
    var closeSockets = useRef();
    var hasConnectionErrors = useRef({
        checkShort: function () { return true; },
        checkLong: function () { return true; },
    });
    var _f = useState(''), socketBaseUrl = _f[0], setSocketBaseUrl = _f[1];
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setSocketBaseUrl;
                        return [4 /*yield*/, userStore.getSocketBaseUrl()];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    useEffect(function () {
        if (waitingToReconnect)
            return;
        if (socketBaseUrl && !clientRef.current && (long ? (longCoin && longContractSize) : true) && (short ? (shortCoin && shortContractSize) : true)) {
            createSocketConnection({
                type: type,
                long: long,
                short: short,
                longCoin: longCoin,
                shortCoin: shortCoin,
                shortContractSize: shortContractSize,
                longContractSize: longContractSize,
                onLongOrderbook: function (_a) {
                    var asks = _a.asks, bids = _a.bids;
                    if (!long) {
                        return;
                    }
                    setStatistics(function (prev) {
                        var _a, _b, _c, _d;
                        if (!prev) {
                            return undefined;
                        }
                        if ('long' in prev) {
                            return __assign(__assign({}, prev), { long: __assign(__assign({}, prev.long), { orderbook: { asks: asks || ((_a = prev.long.orderbook) === null || _a === void 0 ? void 0 : _a.asks) || [], bids: bids || ((_b = prev.long.orderbook) === null || _b === void 0 ? void 0 : _b.bids) || [] } }) });
                        }
                        if ('orderbook' in prev) {
                            return __assign(__assign({}, prev), { orderbook: { asks: asks || ((_c = prev.orderbook) === null || _c === void 0 ? void 0 : _c.asks) || [], bids: bids || ((_d = prev.orderbook) === null || _d === void 0 ? void 0 : _d.bids) || [] } });
                        }
                    });
                },
                onShortOrderbook: function (_a) {
                    var asks = _a.asks, bids = _a.bids;
                    if (!short) {
                        return;
                    }
                    setStatistics(function (prev) {
                        var _a, _b, _c, _d;
                        if (!prev) {
                            return undefined;
                        }
                        if ('short' in prev) {
                            return __assign(__assign({}, prev), { short: __assign(__assign({}, prev.short), { orderbook: { asks: asks || ((_a = prev.short.orderbook) === null || _a === void 0 ? void 0 : _a.asks) || [], bids: bids || ((_b = prev.short.orderbook) === null || _b === void 0 ? void 0 : _b.bids) || [] } }) });
                        }
                        if ('orderbook' in prev) {
                            return __assign(__assign({}, prev), { orderbook: { asks: asks || ((_c = prev.orderbook) === null || _c === void 0 ? void 0 : _c.asks) || [], bids: bids || ((_d = prev.orderbook) === null || _d === void 0 ? void 0 : _d.bids) || [] } });
                        }
                    });
                },
            }).then(function (_a) {
                var close = _a.close, checkErrors = _a.checkErrors;
                closeSockets.current = close;
                hasConnectionErrors.current = checkErrors;
            });
            var socketType = '';
            if (long && short) {
                socketType = type;
            }
            if (!long) {
                socketType = "short";
            }
            if (!short) {
                socketType = "long";
            }
            var exchange = '';
            if (long && short) {
                exchange = type == 'margin' ? short : long;
            }
            else {
                exchange = long || short || '';
            }
            var exchange2 = '';
            if (long && short) {
                exchange2 = type == 'margin' ? long : short;
            }
            else {
                exchange2 = chain || '';
            }
            var socket_1 = new WebSocket("".concat(socketBaseUrl, "/threads/").concat(socketType, "@").concat(coin, "@").concat(exchange, "@").concat(exchange2, "?token=").concat(userStore.authToken));
            clientRef.current = socket_1;
            socket_1.onerror = function (e) { return console.error(e); };
            socket_1.onopen = function () { return socket_1.send('ping'); };
            socket_1.onclose = function () {
                if (!clientRef.current)
                    return;
                if (waitingToReconnect)
                    return;
                setWaitingToReconnect(true);
                setTimeout(function () { return setWaitingToReconnect(false); }, 5000);
            };
            socket_1.addEventListener('message', function (msg) {
                var _a, _b;
                if (msg.data === "ping") {
                    socket_1.send("ping");
                }
                else if (typeof (msg === null || msg === void 0 ? void 0 : msg.data) === "string") {
                    var data_1 = JSON.parse(msg === null || msg === void 0 ? void 0 : msg.data);
                    if ('long' in data_1) {
                        data_1.long.name = exchangesStore.getNameByMarket(long);
                        data_1.short.name = exchangesStore.getNameByMarket(short);
                    }
                    else {
                        data_1.name = long ? exchangesStore.getNameByMarket(long) : exchangesStore.getNameByMarket(short);
                    }
                    if ('orderbook' in data_1) {
                        data_1.orderbook = {
                            //@ts-ignore
                            asks: (_a = data_1.orderbook) === null || _a === void 0 ? void 0 : _a.ask,
                            //@ts-ignore
                            bids: (_b = data_1.orderbook) === null || _b === void 0 ? void 0 : _b.bid
                        };
                        data_1.longShort = long ? "long" : "short";
                    }
                    setStatistics(function (prev) {
                        if (long && long !== "lbank" && long !== 'phemex' && !hasConnectionErrors.current.checkLong()) {
                            if ('long' in data_1 && prev && 'long' in prev) {
                                data_1.long.orderbook = prev === null || prev === void 0 ? void 0 : prev.long.orderbook;
                            }
                            else if ('orderbook' in data_1 && prev && 'orderbook' in prev) {
                                data_1.orderbook = prev.orderbook;
                            }
                        }
                        if (short && short !== "lbank" && short !== 'phemex' && !hasConnectionErrors.current.checkShort()) {
                            if ('short' in data_1 && prev && 'short' in prev) {
                                data_1.short.orderbook = prev === null || prev === void 0 ? void 0 : prev.short.orderbook;
                            }
                            else if ('orderbook' in data_1 && prev && 'orderbook' in prev) {
                                data_1.orderbook = prev.orderbook;
                            }
                        }
                        return data_1;
                    });
                }
            });
            return (function () {
                var _a;
                clientRef.current = null;
                socket_1.close();
                (_a = closeSockets.current) === null || _a === void 0 ? void 0 : _a.call(closeSockets);
            });
        }
    }, [waitingToReconnect, longCoin, shortCoin, shortContractSize, longContractSize, socketBaseUrl]);
    return (jsxs(GraphStyled, { children: [jsxs(GraphContainer, __assign({ style: { display: mobileStore.isChartVisible() ? "initial" : "none" } }, { children: [jsxs(TimeFrameStyled, __assign({ style: { backgroundColor: themeStore.bgColor } }, { children: [jsx("h2", __assign({ className: 'rs', style: { color: themeStore.textColor } }, { children: coin })), jsx(Dropdown$1, { value: timeFrame.title, setValue: function (title) {
                                    setTimeFrame(chartStore.timeFrames.find(function (tf) { return tf.title === title; }) || chartStore.timeFrames[0]);
                                }, options: chartStore.timeFrames.map(function (tf) { return tf.title; }), className: 'timeframe-dropdown' })] })), jsx(Chart, { type: type, coin: coin, long: long, short: short, statistics: statistics, timeFrame: timeFrame.value, chain: chain })] })), jsxs(InfoContainer, __assign({ style: { display: mobileStore.isInfoVisible() ? "flex" : "none" } }, { children: [jsx(UpperInfo, { type: type, statistics: statistics, coin: coin, isVisible: isVisible }), jsx(LowerInfo, { statistics: statistics })] }))] }));
});

var WindowWrapStyled = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    position: relative;\n    height: calc(100vh - ", ");\n    width: 100%;\n    overflow-y: auto;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .close {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .swap-mode-btn {\n        position: absolute;\n        right: 16px;\n        top: 64px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n\n        display: none\n    }\n\n    @media(max-width: calc(2*", ")) {\n      min-width: auto!important;\n\n      .close {\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n      }\n\n      .swap-mode-btn {\n        display: initial;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n"], ["\n    position: relative;\n    height: calc(100vh - ", ");\n    width: 100%;\n    overflow-y: auto;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .close {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .swap-mode-btn {\n        position: absolute;\n        right: 16px;\n        top: 64px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n\n        display: none\n    }\n\n    @media(max-width: calc(2*", ")) {\n      min-width: auto!important;\n\n      .close {\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n      }\n\n      .swap-mode-btn {\n        display: initial;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n"])), HEADER_HEIGHT, BLUE, MIN_INFO_WIDTH, BLUE);
var templateObject_1$1;

var WindowWrap = observer(function (_a) {
    var children = _a.children, index = _a.index, visibleIndex = _a.visibleIndex, onClose = _a.onClose;
    var wrap = useRef(null);
    useEffect(function () {
        if (index === visibleIndex) {
            //@ts-ignore
            wrap.current.scrollIntoView();
        }
    }, [visibleIndex]);
    useResize(function () {
        if (index === visibleIndex) {
            //@ts-ignore
            wrap.current.scrollIntoView();
        }
    }, [index, visibleIndex]);
    return (jsx(Fragment, { children: jsxs(WindowWrapStyled, __assign({ style: {
                minWidth: onClose ? "calc(2*".concat(MIN_INFO_WIDTH, ")") : 'none',
            }, ref: wrap }, { children: [onClose &&
                    jsx(CloseIcon, { className: "close", style: { color: themeStore.textColor }, onClick: function () { onClose(); } }), onClose &&
                    jsx(SwapHorizIcon, { className: "swap-mode-btn", style: { color: themeStore.textColor }, onClick: function () { return mobileStore.changeChartMode(); } }), children] })) }));
});

var NotFoundPage = observer(function () {
    return (jsx(WindowWrap, { children: jsx("h1", __assign({ style: { color: themeStore.textColor, fontSize: '4em' } }, { children: "Page Not Found" })) }));
});

var ScrollWrapStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-right: ", ";\n"], ["\n    padding-right: ", ";\n"])), SCROLL_WIDTH);
var ScrollStyled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    right: 0;\n    top: ", ";\n    width: ", ";\n    height: calc(100vh - ", ");\n    z-index: 10;\n\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: fixed;\n    right: 0;\n    top: ", ";\n    width: ", ";\n    height: calc(100vh - ", ");\n    z-index: 10;\n\n    display: flex;\n    flex-direction: column;\n"])), HEADER_HEIGHT, SCROLL_WIDTH, HEADER_HEIGHT);
var ScrollBar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    h3 {\n        transform: rotate(-90deg);\n        white-space: nowrap;\n\n        @media(max-height: 750px) {\n            font-size: 0.8em;\n        }\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n"], ["\n    position: relative;\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    h3 {\n        transform: rotate(-90deg);\n        white-space: nowrap;\n\n        @media(max-height: 750px) {\n            font-size: 0.8em;\n        }\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n"])));
var StatisticsPageStyled = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    margin-top: ", ";\n\n    max-height: calc(100vh - ", ");\n    overflow-y: hidden;\n"], ["\n    position: relative;\n    margin-top: ", ";\n\n    max-height: calc(100vh - ", ");\n    overflow-y: hidden;\n"])), HEADER_HEIGHT, HEADER_HEIGHT);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var StatisticsPage = observer(function (props) {
    var PlotGraphMenu = props.PlotGraphMenu, UpperInfo = props.UpperInfo, LowerInfo = props.LowerInfo;
    var _a = useState(0), pagesCount = _a[0], setPagesCount = _a[1];
    var _b = useState(0), visibleIndex = _b[0], setVisibleIndex = _b[1];
    var _c = useState([]), graphs = _c[0], setGraphs = _c[1];
    var onCreate = useCallback(function (_a) {
        var type = _a.type, coin = _a.coin, chain = _a.chain, long = _a.long, short = _a.short;
        if (visibleIndex !== pagesCount) {
            return;
        }
        setPagesCount(pagesCount + 1);
        setGraphs(__spreadArray(__spreadArray([], graphs, true), [{ id: Math.random(), type: type, coin: coin, long: long, chain: chain, short: short, isVisible: true, UpperInfo: UpperInfo, LowerInfo: LowerInfo }], false));
    }, [pagesCount, graphs, visibleIndex]);
    return (jsxs(ScrollWrapStyled, { children: [jsx(ScrollStyled, { children: pagesCount > 0 && new Array(Math.min(pagesCount + 1, 5)).fill(0).map(function (val, i) {
                    var _a;
                    return jsx(ScrollBar, __assign({ style: {
                            height: "calc((100vh - ".concat(HEADER_HEIGHT, ")/").concat(Math.min(pagesCount + 1, 5), ")"),
                            backgroundColor: i === visibleIndex ? BLUE : themeStore.bgColor,
                            border: "1px solid ".concat(themeStore.textColor)
                        }, onClick: function () {
                            setVisibleIndex(i);
                        } }, { children: jsx("h3", __assign({ className: "rs", style: { color: i === visibleIndex ? WHITE : themeStore.textColor } }, { children: (((_a = graphs[i]) === null || _a === void 0 ? void 0 : _a.coin.replace("USDT", "")) || '') +
                                (graphs.filter(function (g) { var _a; return g.coin === ((_a = graphs[i]) === null || _a === void 0 ? void 0 : _a.coin); }).length > 1 ? " ".concat(graphs.slice(0, i + 1).filter(function (g) { var _a; return g.coin === ((_a = graphs[i]) === null || _a === void 0 ? void 0 : _a.coin); }).length) : '')
                                || "Добавить" })) }), i);
                }) }), jsxs(StatisticsPageStyled, __assign({ id: "statistics-page" }, { children: [graphs.map(function (graph, i) {
                        return jsx(WindowWrap, __assign({ index: i, visibleIndex: visibleIndex, onClose: function () {
                                setPagesCount(pagesCount - 1);
                                setGraphs(graphs.filter(function (g) { return g.id !== graph.id; }));
                            } }, { children: jsx(Graph, { id: graph.id, isVisible: i === visibleIndex, type: graph.type, coin: graph.coin, long: graph.long, chain: graph.chain, short: graph.short, UpperInfo: UpperInfo, LowerInfo: LowerInfo }) }), graph.id);
                    }), jsx(WindowWrap, __assign({ index: pagesCount, visibleIndex: visibleIndex }, { children: jsx(PlotGraphMenu, { onCreate: onCreate, showBtn: (pagesCount < 5) }) }))] })), jsx(AuthForm, { isOpen: !userStore.isAuth })] }));
});

export { AUTH_TOKEN, AuthForm, BASE_URL, BLACK, BLUE, Button, DARK_GREY, DARK_RED, Dropdown$1 as Dropdown, GOLD, GREEN, GREY, Graph, HEADER_HEIGHT, Header, LIGHT_BLACK, Loader, Logo, MIN_INFO_WIDTH, Modal, NotFoundPage, RED, REFRESH_TOKEN, SCROLL_WIDTH, SearchSelect, StatisticsPage, StringContainer, TextInput, ThemePicker, WHITE, chartStore, exchangesStore, getCloseSpread, getEnterSpread, getFormatedLocalTime, getGeneralTitles, getHeaders, getLongShortTitles, isNewTimeFrame, mobileStore, shortExchanges, showNotification, themeStore, typeOptions, useCheckMobile, useDebounce, useGetCoinForMarket, useGetContractSize, useResize, userStore, wait, wasDisconnected, withRetry };
